import { parseScanCodeUtils } from 'pangu-core'
import * as scanUtils from '../../../static/js/scanUtils'
import lodashUtils from '../../../static/js/lodashUtils'
import objectUtil from '../../../static/js/objectUtil'
import templateUtil from '../../../static/js/templateUtil'
import calculateUtil from '../../../static/js/calculateUtil'
import ScanCore from '../core'

const regs = {
  gs1: /^01.*?/,
  ma: /^MA\S{8}.*?(?=(\.[A-Z]|$))/,
  hibc: /^\+A.*?/,
}

/**
 * 共通的逻辑和方法
 *
 */
export default {
  data() {
    return {
      /********** 扫码解析部分 **********/
      // 单次扫解析的结果，此变量只存储 data 部分
      scanCurrentResult: new Map(),
      // 存储解析的结果，data 是 map 数据结构
      scanResult: {
        success: false,
        origin: null,
        codeType: null,
        print: null,
        data: new Map(),
      },
      // 扫码区表单数据
      scanFormData: {
        [this.dataGoodsInfoKey]: {},
        [this.dataGoodsKeepingKey]: { epc: null, serialNumber: null },
        [this.dataGoodsPreserveKey]: {},
      },
      // 扫码暂存后的 formData
      formDataAfterScan: null,
      // 存储扫码查询到的商品信息
      goodsInfo: {},
      // 上方表格的搜索关键字
      keyword: '',
      // 扫码后与获取的商品 DI 匹配的数据，来获取任务数据（不会显示在上方表格的数据）
      tableData: [],
      // 任务数据（会显示在上方表格中）
      taskData: [],
      // 表格树配置
      treeConfig: {
        rowField: 'id',
        parentField: 'parent',
        expandAll: false,
      },
      // 扫码的当前步骤
      scanCurrentStep: this.allStep?.[0],
      // 扫码表单状态：编辑（update）| 新增（create）
      scanStatus: 'create',
      code: '', // 扫码获取到的数据（字符串）
      analysisCodeType: null, // 解析后识别出的码类型
      analysisMessages: [], // 解析后可展示的数据
      warnOrErrorMessage: '', // 警告或错误的提示信息内容
      warnOrErrorMessageType: '', // 提示信息的类型 警告: warn | 错误: error
      mark: [],
      defaultMark: '', // 扫码枪默认标识
      defaultMarkKey: '',
      isBracket: 'YES',
      /********** 组件部分 **********/
      hideTask: false,
      hideTaskBtnDisabled: false,
      // 扫码区表格数据
      scanTableData: [],
      // 扫码模式：自动识码(AUTO) / GS1(GS1)) / HIBC码(HIBC) / MA码(MA) / 69码 / 自定义序列号(CUSTOM_SERIALNUMBER)
      scanType: 'AUTO',
      // 错误提示，eg. { errors: [{ level: 1, message: '报错啦！', row: 1 }] }
      topRemindErrors: null,
      /* 抽屉 Drawer */
      drawerWidth: 0,
      // 商品 ids
      detailIds: [],
      // 复选框选中对象, 接口 {[row._ID]: row}
      selectionIds: {},
      // Table 高度
      tableHeight: 0,
      // 待选择的规格/型号
      medicalData: null,
      // 货位数据
      locationInfo: {},
      // 已选中规格/型号的执行函数，isSelectModel = false 时，重置为 null
      resolveSelectModel: null,
      // 是否锁定
      isLock: false,
      // 是否选择规格
      isSelectModel: false,
      // 是否可提交保存
      isSave: false,
      // 是否可确认提交
      isScanConfirm: true,
      // 模式：标准模式(standard) / 序列号连续扫模式(series)
      mode: 'standard',
      // 是否禁用锁定
      disabledLock: false,
      // 是否正在暂存中
      isPureSaving: false,
      // #6805 扫码识别兼容处理后禁止必填校验，第2次请求成功后将此值赋值为true
      disabledValidRequired: false,
      //********** 日期（保质期）反算 **********//
      /*
       * 是否支持双向反算效期 ISCC_TWO_WAY_PERIOD
       *
       * 全部支持: ALL
       * 正向: POSITIVE
       * 逆向: NEGATIVE
       * 不支持: NO
       *
       */
      policy: null,
      //********** 日期（保质期）反算 End **********//
      // 扫码模式，普通模式(default) / 批量模式(multiple)
      scanMode: 'default',
      scanPreTime: null,
      PI: [],
      OI: [],
      timeId: null,
      // 扫码输入框的值
      inputValue: '',
    }
  },
  props: {
    // 兼容Bug: #31920。如果此值为 true 则依然传递 targetId
    passTargetId: { type: Boolean, default: false },
    // 验收结论的默认值
    acceptResultDefault: {
      type: Object,
      default: () => ({
        id: '339f97fd-1da7-42b8-9947-9e776bffa24c',
        code: 'ACCEPT_RESULT_30',
        name: '合格',
      }),
    },
    // 是否禁用自动提交
    disabledAutoSubmit: {
      type: Boolean,
      default: false,
    },
    // 表格行合并规则
    treeRes: {
      type: String,
      default: 'data.parent',
    },
    // 获取商品失败的错误提示信息
    queryGoodsErrorMessage: {
      type: String,
      default: '请先扫描可以解析出商品名称的条码或确认此商品是否在任务范围',
    },
    // 可展示的解析结果字段名集
    analysisMessagesOptions: {
      type: Array,
      default() {
        return [
          'productIdent',
          'batchNumber',
          'periodBegin',
          'periodEnd',
          'periodExpire',
          'serialNumber',
          'amount',
        ]
      },
    },
    // 识别失败的错误提示信息
    analysisErrorMessage: {
      type: String,
      default: '无法解析此条码，请核查后重试！',
    },
    // 有参照报错的提示信息
    referErrorMessage: {
      type: String,
      default: '此商品不在任务范围内',
    },
    // 已扫数量不正确的提示信息
    amountErrorMessage: {
      type: String,
      default: '累计扫码数量已经超出了待处理数量，请仔细检查！',
    },
    // 未匹配到数据
    nodataErrorMessage: {
      type: String,
      default: '未匹配到数据，或任务已完成',
    },
    // 没有查询到货位的提示信息
    locationErrorMessage: {
      type: String,
      default: '没有查询到货位',
    },
    // #6805 重试成功后的提示信息
    tryRequestMessage: {
      type: String,
      default: '虽然成功检索到商品，但此GS1条码的格式并不规范，PI信息无法自动识别',
    },

    // 是否启用单条模式
    isSingle: {
      type: Boolean,
      default: false,
    },
    // 是否禁用删除功能（不可见）
    disableDeleted: {
      type: Boolean,
      default: false,
    },
    // 是否显示弹窗
    value: {
      type: Boolean,
      default: true,
    },
    // 弹窗宽度 或 Input 组件的输入框宽度
    width: {
      type: [String, Number],
      default: '100%',
    },
    // 左侧位置偏移量
    offset: {
      type: Number,
      default: 200,
    },
    // 标题
    title: {
      type: String,
      default: '开始扫码',
    },
    // 是否将弹层放置于 body 内
    transfer: {
      type: Boolean,
      default: true,
    },
    // 扫码输入框（识别商品）的 placeholder
    placeholder: {
      type: String,
      default: '请先扫描能够识别商品的条码',
    },
    // 搜索输入框的 placeholder
    searchPlaceholder: {
      type: String,
      default: '搜索商品',
    },
    // 表单数据，注意: 在 methods.startSave 方法中执行了整个表单数据的更新新
    formData: {
      type: Object,
      default() {
        return {}
      },
    },
    // 表格数据
    dataSource: {
      type: Array,
      default() {
        return []
      },
    },
    // 扫码类别配置
    scanOptions: {
      type: Array,
      default: () => [
        {
          label: '自动识码',
          value: 'AUTO',
        },
        {
          label: 'GS1码',
          value: 'GS1',
        },
        {
          label: 'HIBC 码',
          value: 'HIBC',
        },
        {
          label: 'MA 码',
          value: 'MA',
        },
        {
          label: '普通码',
          value: '69',
        },
        {
          label: '自定义序列号',
          value: 'CUSTOM_SERIALNUMBER',
        },
      ],
    },
    // 定义商品数据的属性名。默认: goodsDetail
    dataGoodsInfoKey: {
      type: String,
      default: 'goodsDetail', // 可能值 goodsDetail / goodsInfo
    },
    // 定义商品数据 goodsKeeping 的属性名。
    dataGoodsKeepingKey: {
      type: String,
      default: 'goodsKeeping', // 可能值 goodsKeeping / goodsStore
    },
    // 定义商品数据 preserve 的属性名。
    dataGoodsPreserveKey: {
      type: String,
      default: 'preserve',
    },
    // 定义返回数据中的已扫数量的属性名。用于确认提交时，验证已扫数量<=待处理数量
    dataAmountKey: {
      type: String,
      default: 'amount', // 可能的值 amount
    },
    // 定义返回数据中的库存可供数量的属性名。用于校验库存数据范围
    dataAvailableKey: {
      type: String,
      default: 'available',
    },
    // 定义返回数据中的待处理数量的属性名。用于确认提交时，验证已扫数量<=待处理数量
    dataPendingKey: {
      type: String,
      default: 'plan', // 可能的值 plan
    },
    // 获取表格数据的参数
    requestTableDataParameters: {
      type: Object,
    },
    // 获取表格数据的接口地址
    tableDataUrl: {
      type: String,
      default: '',
    },
    // 获取表格数据详细信息的接口地址，mock 地址为：rest/main/goods/query?id=id
    tableDataInfoUrl: {
      type: String,
      default: '',
    },
    // 获取表格数据详细信息的接口的传递参数
    tableDataInfoParameters: {
      type: Object,
    },
    // 获取保质期的接口地址
    validDateUrl: {
      type: String,
      default: 'rest/main/goods/goods/queryPeriod',
    },
    // 保存接口地址，mock 地址为：rest/main/scan/save
    saveUrl: {
      type: String,
      default: '',
    },
    // 请求保存接口的参数
    saveParams: {
      type: Object,
      default() {
        return {}
      },
    },
    // // 获取货位的表格数据的接口地址,
    // locationDataInfoUrl: {
    //   type: String,
    //   default: 'rest/ezscc/store/locationPaged',
    // },
    // // 获取货位的表格列定义
    // locationColumnDefUrl: {
    //   type: String,
    //   default: 'rest/main/dict/getTableByCode?tableCode=LINK_SCAN_LOANTION_TABLE',
    // },
    // 扫码获取货位的数据
    locationScanInfoUrl: {
      type: String,
      default: 'rest/ezscc/scan/scanLocation',
    },
    // 扫码获取货位的数据的接口参数
    locationScanInfoParams: {
      type: Object,
      default() {
        return {}
      },
    },
    // 扫码获取推荐货位的接口
    locationScanInfoOfRecommend: {
      type: String,
      default: 'rest/ezscc/store/getRecommendLocation',
    },
    // 扫码获取推荐货位的接口参数
    locationScanInfoOfRecommendParams: {
      type: Object,
      default() {
        return {}
      },
    },
    //区分不同模式
    //checkout----带入任务明细，匹配扫码的信息，进行数量累加
    //import---带入任务明细，根据扫码的商品匹配任务明细，将扫码其他信息带入任务明细
    model: {
      type: String,
      default: 'checkout',
    },
    disabledPureSave: {
      type: Boolean,
      default: false,
    },
    // 扫码结果暂存服务端的暂存接口地址
    pureSaveOfUrl: {
      type: String,
      default: 'rest/main/store/receipt/draft',
    },
    // 表单项【效期】后面，是否显示，“无值”按钮
    showEmptyBtn: {
      type: Boolean,
      default: true,
    },
    /** @name 通过扫码添加明细时触发反算的工具类（为null时不触发反算） */
    useBackCountAddItems: {
      type: String,
      default: 'orderBackCountUtil',
    },
    /** @name 是否开启根据系统策略IWMS_SCAN_AUTO_OPEN_SERIAL的值判断是否扫码自动开启序列号管理 */
    isCheckAutoSerial: {
      type: Boolean,
      default: false,
    },
    /** @name 扫码识别兼容处理请求成功后是否弹出提示信，相关需求#6805 */
    isTryRequest: { type: Boolean, default: false },
    /** @name 是否开启批量扫码模式 */
    openScanMultiple: {
      type: Boolean,
      default: false,
    },
    /****************** 药械闪加 - 扫码添加组件相关 ******************/
    // 扫码添加（新扫码）是否禁止调用接口：searchMedicalList
    disabledScanSearchMedicalList: {
      type: Boolean,
      default: true,
    },
    // 调此接口过滤选择商品规格后的数据
    searchMedicalListUrl: {
      type: String,
      default: 'rest/main/flashplus/queryGoodsListForFlash',
    },
    // 调接口 searchMedicalListUrl 传递的参数
    searchMedicalListOfParams: {
      type: Object,
      default() {
        return {}
      },
    },
    /****************** 药械闪加 - 扫码添加组件相关 End ******************/
    /****************** 设置扫码商品属性相关 ******************/
    isScanProperty: {
      type: Boolean,
      default: false,
    },
    // 组件 setGoodOfScanProperty.vue 的 props，请参考它的 Props 设置
    scanPropertyProps: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    filterTableData() {
      const keyword = this.keyword
      const dataGoodsInfoKey = this.dataGoodsInfoKey

      /** @name 启用单条模式 */
      if (this.isSingle) {
        let data = this.taskData ?? []

        if (!lodashUtils.isNone(keyword)) {
          const regx = new RegExp(keyword, 'ig')
          data = data.filter(
            (row) =>
              regx.test(row[dataGoodsInfoKey]?.name) || regx.test(row[dataGoodsInfoKey]?.code)
          )
        }

        this.treeConfig.expandAll = data.length < 100
        return data
      }

      /** @name 关闭单条模式 */
      let _tableData = this.tableData ?? []

      if (!lodashUtils.isNone(keyword)) {
        const regx = new RegExp(keyword, 'ig')
        const _data = _tableData.filter(
          (row) => regx.test(row[dataGoodsInfoKey]?.name) || regx.test(row[dataGoodsInfoKey]?.code)
        )
        this.treeConfig.expandAll = _data.length < 200
        return _data
      } else {
        this.treeConfig.expandAll = _tableData.length < 200
        return _tableData
      }
    },
    // 当前扫码类型
    currentScanType() {
      const map = {
        AUTO: ['hibc', 'ma', 'gs1', 'hw'],
        GS1: ['gs1'],
        HIBC: ['hibc'],
        MA: ['ma'],
      }

      return map[this.scanType]
    },
    // 扫码后获取到的商品，是否开启单品序列号管理
    keepingSerial() {
      return this.scanFormData[this.dataGoodsInfoKey]?.keepingSerial
    },
    // 扫码后获取到的商品，是否开启单品自定义序列号管理
    keepingCustomSerial() {
      return (
        this.scanFormData[this.dataGoodsInfoKey]?.keepingCustomSerial ||
        this.scanFormData[this.dataGoodsInfoKey]?.keepingRfidSerial ||
        this.scanFormData[this.dataGoodsInfoKey]?.keepingExclusiveSerial
      )
    },
    // 系统类型是否是灵科
    isLinkOfSystem() {
      return this.dataGoodsKeepingKey === 'goodsStore'
    },
    // 验收结论的 key
    acceptResultKey() {
      return this.isLinkOfSystem ? 'acceptStatus' : 'attrs.valueEnum.acceptResult'
    },
    // 单据
    order() {
      return this.formData?.order
    },
    // 单据 id
    orderId() {
      const route = this.$route || window.$vueApp.$route
      const orderId = this.formData?.order?.id
      return orderId ?? route?.query?.id
    },
    // 需求#6553，新增的系统策略IWMS_SCAN_AUTO_OPEN_SERIAL
    isAutoSerial() {
      return (
        !this.isCheckAutoSerial ||
        objectUtil.getValueByPath(
          this.$store,
          'state.strategy.strategy.IWMS_SCAN_AUTO_OPEN_SERIAL'
        ) === 'YES'
      )
    },
    /********** 需求#5711，验收环节扫码组件的日期处理优化 **********/
    // 是否正向计算
    isPositive() {
      const policy = this.policy
      // 是否进行正向计算
      const isPositive = !policy || policy === 'ALL' || policy === 'POSITIVE'

      console.log('是否进行正向计算: ', isPositive)
      return isPositive
    },
    // 是否逆向计算
    isNegative() {
      const policy = this.policy
      // 是否进行逆向计算
      const isNegative = policy === 'ALL' || policy === 'NEGATIVE'

      console.log('是否进行逆向计算: ', isNegative)
      return isNegative
    },
    /********** 需求#5711，验收环节扫码组件的日期处理优化 End **********/
  },
  watch: {
    scanResult: {
      handler(data) {
        console.log('当前存储的解析数据: ', data)
      },
      deep: true,
    },
    scanFormData: {
      handler: lodashUtils.debounce(function (data) {
        console.log('当前扫码表单数据: ', data)
        if (this.warnOrErrorMessageType === 'error') return
        // 根据扫到的条码生成厂家原始条码
        // this.createOriginBarCode()

        this.$nextTick(() => {
          const num = data?.[this.dataAmountKey]
          if (num === 0) this.scanFormData[this.dataAmountKey] = 1
        })
      }, 1500),
      deep: true,
    },
    // scanFormData.amount 为 0 时，重设为 1 `${this.dataAmountKey}`
    // 'scanFormData.amount': lodashUtils.debounce(function (amount) {
    //   this.$nextTick(() => {
    //     if (amount === 0) this.scanFormData.amount = 1
    //   })
    // }, 1500),
    scanCurrentStep: {
      handler(step) {
        console.log(`当前步骤(${step.name}): `, step.code)
      },
      deep: true,
    },
    tableData: {
      handler(data) {
        console.log('table data: ', data)
      },
      deep: true,
    },
    taskData: {
      handler(data) {
        console.log('task data: ', data)
        if (data?.length === 0) this.isSave = false
      },
      deep: true,
    },
    scanTableData: {
      handler(data) {
        this.$nextTick(() => {
          // this.calcTableHeight() // 下方表格高度发生变化时，重新计算上方表格的高度
          if (data && data.length > 0) this.$refs?.scanTable?.setCurrentRow(data[0])
        })
      },
      deep: true,
    },
    isSelectModel(val) {
      // this.isSelectModel = false 时，this.resolveSelectModel 重置为 null
      if (!val) this.resolveSelectModel = null
    },
    scanMode(mode) {
      if (mode === 'default') {
        this.$Message.warning('已切换至【单扫模式】')
      } else {
        this.$Message.warning('已切换至【批量扫码模式】')
      }
    },
  },
  created() {
    this.defaultMark = objectUtil.getValueByPath(
      this.$store,
      'state.strategy.strategy.IECM_GS1_FNC1_SWEEPING_GUN',
      '96,98,105'
    )
    this.defaultMarkKey = objectUtil.getValueByPath(
      this.store,
      'state.strategy.strategy.IECM_GS1_FNC1_SWEEPING_GUN_COMBINATION',
      'altKey'
    )
    this.isBracket = objectUtil.getValueByPath(
      this.$store,
      'state.strategy.strategy.ISCC_ORIGIN_BARCODE_BRACKET',
      'YES'
    )
    console.log('$store: ', this.$store)
    console.log('isBracket: ', this.isBracket)
    // 获取日期反算的策略
    this.getPolicySetting()
  },
  methods: {
    // 打印 Map 数据结构的数据
    consoleMap(data) {
      for (let [key, value] of data) {
        console.log(key, value)
      }
    },
    getInputFocus() {
      setTimeout(() => {
        this.$refs.areaScanInput.focus()
      }, 300)
    },
    /********** 扫码解析部分 **********/
    // 初始化
    init() {
      this.$nextTick(() => {
        window.onresize = () => {
          // 监听窗口大小变化
          this.calcDrawerWidth()
          this.calcTableHeight()
        }
      })
    },
    initComponent(height = 0, disabled = false) {
      this.$nextTick(() => {
        this.getInputFocus()
        // 先重置
        this.reset()
        if (!disabled) {
          // 数据初始
          this.initSource()
          // 计算表格的高度上限
          this.calcDrawerWidth()
          this.calcTableHeight(height)
        }
        // 表单初始化
        this.setAreaColumns()
      })
    },
    async initSource() {
      console.log('formData: ', this.formData)
      console.log('dataSource: ', this.dataSource)
      // 重置 taskData
      this.taskData = []

      if (this.tableData?.length === 0) {
        if (this.tableDataUrl) {
          // props.tableDataUrl 配置时，以请求接口返回的数据为准
          this.tableData = await this.getTableData()
        } else {
          // props.tableDataUrl 未配置时，以传入的 dataSource 的数据为准
          this.tableData = objectUtil.clone(this.dataSource ?? [])
        }
      }
    },
    /********** 扫码解析部分 **********/
    // 显示或隐藏扫码任务
    showOrHideTask() {
      this.hideTaskBtnDisabled = true
      this.hideTask = !this.hideTask

      setTimeout(() => {
        this.hideTaskBtnDisabled = false
      }, 3000)
    },
    /**
     * 生成扫码解析结果的展示数据
     * 数据的结构：
     * {
     *   label: 标签名（即解析识别的数据类别，eg: 批号）,
     *   value：显示的值（eg. 批号的值）
     * }
     *
     * @param {Object} res 扫码解析的结果
     *
     */
    setAnalysisMessages(res) {
      const data = res.data
      const analysisMessagesOptions = this.analysisMessagesOptions
      let assignedGtin = false // 是否已处理 gtin

      // 先重置
      this.analysisMessages = []
      // 生成新的数组
      this.analysisMessages = analysisMessagesOptions.reduce((prev, key) => {
        const item = {}

        if (data[key]?.value) {
          item.label = data[key].label
          item.value = data[key].value
        }
        // gtin 有值
        else if (!assignedGtin && data.gtin?.value) {
          item.label = '产品标识'
          item.value = data.gtin.value
          assignedGtin = true
        }

        if (!lodashUtils.isEmpty(item)) prev.push(item)

        return prev
      }, [])
      console.log('生成扫码解析结果的展示数据返回的数据：', this.analysisMessages)
    },
    onInputCode(code) {
      this.inputValue = code
    },
    /**
     * 扫码事件监听
     *
     * @param {event} evt 输入框事件
     */
    async keyDownSearchCode(evt) {
      let code = this.inputValue // 获取扫码枪扫出的条码
      const keycode = evt.keyCode || evt.which || evt.charCode
      console.log('捕获扫码后触发的事件: ', keycode, code, evt)
      // eslint-disable-next-line vue/no-parsing-error
      // 排除某些电脑通过ASCII码直接输入分隔符， 的 ASCII 码: \x1D charCode: 29
      const regx = new RegExp(`${String.fromCharCode(29)}|\\x81`, 'g')
      if (regx.test(code)) {
        evt.srcElement.value = evt.srcElement.value.replace(regx, '')
        code = code.replace(regx, '')
      }
      if (keycode == 229 || keycode == 191) {
        let myField = evt.srcElement
        if (['???', '？？？'].includes(myField.value)) {
          this.code = 'SCAN_SUB' // 赋值后，后续可自动确认提交
          return
        }
      }

      if (
        keycode == 119 ||
        this.mark?.join(',') == this.defaultMark ||
        this.mark?.join(',') == '48,50,57' ||
        keycode == this.defaultMark
      ) {
        let myField = evt.srcElement
        let myValue = 'ñ'
        if (myField.selectionStart || myField.selectionStart === 0) {
          let startPos = myField.selectionStart
          let endPos = myField.selectionEnd
          myField.value =
            myField.value.substring(0, startPos) +
            myValue +
            myField.value.substring(endPos, myField.value.length)
          code = myField.value
          myField.focus()
          myField.setSelectionRange(endPos + myValue.length, endPos + myValue.length)
        }
      }
      //处理组合键
      let markKeys = this.defaultMarkKey.split(',')
      if (markKeys) {
        let isOk = true
        markKeys.forEach((markKey) => {
          if (!evt[markKey]) {
            isOk = false
          }
        })
        if (isOk) {
          this.mark.push(keycode)
        } else {
          this.mark = []
        }
      }

      if (keycode == 229) {
        const c = evt.target.value.replace(/[\u4e00-\u9fa5]/g, '')
        this.code = c
        this.inputValue = c
      } else {
        if (/[\u4e00-\u9fa5]/.test(evt.target.value)) {
          this.code =
            evt.target.value.replace(/[\u4e00-\u9fa5]/g, '') + evt.code.replace(/Digit/, '')
          this.inputValue = this.code
          code = this.code
        } else {
          this.code = code
          this.inputValue = code
        }
      }

      // Enter
      const isEneter = keycode === 13 || evt.code === 'Enter'

      if (isEneter) {
        code = evt.target.value
        evt.srcElement.select()
        // 多扫模式
        if (this.scanMode !== 'default') {
          console.log('开始批量扫码模式...')
          // 间隔时间(ms)
          const delay = this.scanMode
          const now = Date.now()
          const diff = now - (this.scanPreTime || 0)
          // 间隔小于 500 ms 缓存扫码结果
          if (!this.scanPreTime || diff < delay) {
            if (this.timeId) {
              clearTimeout(this.timeId)
            }
            if (regs.gs1.test(code) || regs.ma.test(code) || regs.hibc.test(code)) {
              // 如果已扫到过 PI 则提示不可多次扫 PI
              if (this.PI.length > 0) {
                this.updateWarnOrErrorMessage('不可重复扫PI段', 'error')
                return
              }

              this.PI.push(code)
            } else {
              this.OI.push(code)
            }
          }

          this.timeId = setTimeout(async () => {
            // 重新生成 code
            code = `${this.PI[0] || ''}${this.OI.length > 0 ? 'ñ' + this.OI.join('ñ') : ''}`

            // 间隔大于等于500 ms，则执行后续的解码
            this.code = code
            if (['???', '？？？'].includes(code)) {
              this.code = 'SCAN_SUB' // 赋值后，后续可自动确认提交
            }
            code = null
            // 开始解析后逻辑处理
            await this.parsing()

            // 清空
            this.PI = []
            this.OI = []
            this.scanPreTime = null
          }, delay)

          this.scanPreTime = now
          return
        }
        console.log('开始单扫模式...')

        this.code = code
        if (['???', '？？？'].includes(code)) {
          this.code = 'SCAN_SUB' // 赋值后，后续可自动确认提交
        }
        code = null
        // 开始解析后逻辑处理
        await this.parsing()
      }
    },
    /**
     * 根据扫码解析的码结果，执行不同的提示或请求接口
     *
     */
    async startScan(strategy) {
      if (!strategy) throw new Error('策略 strategy 为必填参数，不可为空！')
      const scan = new ScanCore(this, strategy)

      try {
        // 解析
        scan.parse().type().skip()
        // 执行
        await scan.start()
        // 判断 DI 区是否有值
        this.isEmptyDi()
      } catch (error) {
        // error?.message 中包含 disableMessage 则不显示错误提示
        if (!/^disableMessage/.test(error?.message))
          this.updateWarnOrErrorMessage(error?.message, 'error')
        // 未查询到商品，重置 scanFormData
        // this.resetScanFormData() // 先注释掉，报错只给提示不清空表单
      }

      await scan.finally()
    },
    /**
     * @name 指定重试次数发起请求
     * @description #6805
     *
     * @param {Function} fn 请求方法(函数)
     * @param {Object} [params={}] 请求参数
     * @param {Boolean} [showWarning=false] 重试第2次时是否显示提示信息
     *
     */
    tryRequest(fn, params = {}, showWarning = false) {
      // 重试次数
      let count = 0
      // 兼容处理请求，按照需求 #6805 的验收标准：第二次检索商品档案：将识别到的字符串，去掉开头的(01)后，再截取头14位，再次去寻找商品
      const setParam = (_param) => {
        const param = { ..._param }
        if ('gtin' in param) {
          let gtin = param.gtin
          gtin = gtin.replace(/^01/, '')
          gtin = gtin.substring(0, 14)
          param.gtin = gtin
        }

        return param
      }

      /**
       * @param {Number} [num=1] 指定的重试次数
       */
      return async (num = 1) => {
        try {
          const res = await fn(params)

          // 重试第2次时是否显示提示信息
          if (showWarning) {
            this.updateWarnOrErrorMessage(this.tryRequestMessage, 'warn')
          }
          count = 0 // 重置次数
          return res
        } catch (error) {
          count += 1
          if (count < num) {
            // 开启禁止必填校验的开关
            this.disabledValidRequired = this.isTryRequest
            const _params = setParam(params)
            return this.tryRequest(fn, _params, true)(1)
          }

          count = 0 // 重置次数
          throw new Error(error?.message)
        }
      }
    },
    /**
     * 扫码主流程处理函数
     *
     */
    async handlerStart(initalData) {
      const scanType = this.getScanType()
      const isHw = initalData?.type?.isHw ?? scanType.isHw
      const isGS1 = initalData?.type?.isGS1 ?? scanType.isGS1
      const isMa = initalData?.type?.isMa ?? scanType.isMa
      const isHibc = initalData?.type?.isHibc ?? scanType.isHibc
      const { data: scanData } = this.scanResult

      // 非货位码
      if (!isHw) {
        const gtin = scanData.get('gtin')
        const identity = scanData.get('productIdent')
        const params = {}
        // console.log('gtin: ', gtin)
        // console.log('identity: ', identity)
        // 一段式，可能获取到商品 DI 信息
        if (gtin || identity) {
          this.jump({ begin: true })
          // 清空扫码区
          this.resetScanFormData()
          this.resetScanTableData?.()
          if (isGS1) {
            params.gtin = gtin
          }
          // 解析成功，是 MA 或 HIBC 码
          else {
            const _identity = identity || this.scanResult.origin
            if (isMa) {
              params.maIdentity = _identity
            } else if (isHibc) {
              params.hibcIdentity = _identity
            } else {
              params.gtin = _identity
            }
          }
          // 请求接口获取商品信息
          // #6805 指定重试次数为 2
          console.log('是否开启重试请求: ', this.isTryRequest)
          const goods = await this.tryRequest(this.queryTableDataInfo, params)(2)
          // const goods = await this.queryTableDataInfo(params)
          this.goodsInfo = goods
          this.updateScanFormData({ item: goods }) // 更新扫码区表单
          this.skip(goods) // 如果开启了序列号管理，步骤可能会被更新为 epc 或 sn，下次扫码时会已更新后的步骤执行
        } else {
          // 是否是普通码
          const isNormal = this.analysisCodeType === '普通码' || this.scanType === '69'
          // 特殊步骤：
          const isSN = this.scanCurrentStep.code === 'sn'
          if (!isSN && this.scanType === 'CUSTOM_SERIALNUMBER') {
            this.resetScanFormData()
            // 判断是否配置了自定义序列号表单字段
            const epcItem = this.searchFormItem(`${this.dataGoodsKeepingKey}.epc`, [
              this.serialAreaColumns,
            ])
            // 更新解析结果，添加自定义序列号
            if (epcItem || this.scanTableDataInfoUrl || this.goodInfoTableColumnDefUrl) {
              scanData.set('epc', this.scanResult.origin)
              // 数量需要设置为 1
              this.$set(this.scanFormData, `${this.dataAmountKey}`, 1)
            }
            const epcValue = scanData.get('epc')
            // 配置了序列号表单项，则更新其值
            if (epcValue) {
              // 更新表单项
              this.updateScanFormDataForOther()
            } else {
              throw new Error(this.queryGoodsErrorMessage)
            }
          } else {
            // 步骤：扫商品 DI
            if (this.scanCurrentStep.code === 'di') {
              if (isNormal) {
                // 尝试用普通码去调接口获取商品
                params.gtin = this.scanResult.origin
                const goods = await this.queryTableDataInfo(params) // 请求接口获取商品信息
                this.goodsInfo = goods
                this.updateScanFormData({ item: goods }) // 更新扫码区表单
                this.skip(goods)
              } else {
                // 二段式 or 三段式 更新扫码出来的其他信息
                this.updateScanFormDataForOther()
                // 序列号管理商品，可能会扫自定义序列号或原厂序列号
                if (this.keepingSerial || this.keepingCustomSerial) {
                  const { epc, serialNumber } = this.scanFormData[this.dataGoodsKeepingKey]
                  // 判断是否配置了自定义序列号表单字段
                  const epcItem = this.searchFormItem(`${this.dataGoodsKeepingKey}.epc`, [
                    this.serialAreaColumns,
                  ])
                  // 判断是否配置了原厂序列号表单字段
                  const serialItem = this.searchFormItem(
                    `${this.dataGoodsKeepingKey}.serialNumber`,
                    [this.serialAreaColumns]
                  )
                  // 自定义序列号管理，且未扫自定义序列号
                  if (epcItem && this.keepingCustomSerial && !epc) {
                    // 跳转至下一步
                    this.jump({ step: 'epc' })
                  }
                  // 原厂序列号管理，且未扫原厂序列号
                  else if (serialItem && this.keepingSerial && !serialNumber) {
                    // 跳转
                    this.jump({ step: 'sn' })
                  } else {
                    this.resetWarnOrErrorMessage()
                    this.jump({ step: 'pi' })
                  }
                }
                // 非序列号管理商品
                else {
                  this.jump({ step: 'pi' })
                }
              }
            }
            // 步骤：扫商品自定义序列号
            else if (this.scanCurrentStep.code === 'epc') {
              /*
               * 是否将 origin 赋值给 epc
               * 可赋值的情况条件：
               * 1. scanCurrentResult.size === 0 则什么都没解析到
               * 2. isNormal=true 识别为普通码
               */
              if (isNormal || this.scanCurrentResult.size === 0)
                scanData.set('epc', this.scanResult.origin) // 更新解析结果，添加自定义序列号
              // 更新表单
              this.updateScanFormDataForOther()
              // 未锁定
              if (!this.isLock) {
                const epc = scanData.get('epc') || this.scanFormData[this.dataGoodsKeepingKey].epc
                if (epc) {
                  const serialNumber =
                    scanData.get('serialNumber') ||
                    this.scanFormData[this.dataGoodsKeepingKey].serialNumber
                  if (!serialNumber) {
                    this.jump({ step: 'sn' })
                  } else {
                    this.resetWarnOrErrorMessage()
                    // 跳转至 PI
                    this.jump({ last: true })
                  }
                } else {
                  const msg = '请扫自定义序列号'
                  this.updateWarnOrErrorMessage(msg, 'warn')
                }
              }
            }
            // 步骤：扫商品原厂序列号
            else if (this.scanCurrentStep.code === 'sn') {
              /*
               * 是否将 origin 赋值给 serialNumber
               * 可赋值的情况条件：
               * 1. scanCurrentResult.size === 0 则什么都没解析到
               * 2. isNormal=true 识别为普通码
               */
              if (isNormal || this.scanCurrentResult.size === 0)
                scanData.set('serialNumber', this.scanResult.origin)
              // 更新表单
              this.updateScanFormDataForOther()
              // 未锁定
              if (!this.isLock) {
                const serialNumber =
                  scanData.get('serialNumber') ||
                  this.scanFormData[this.dataGoodsKeepingKey].serialNumber
                // 跳转至下一步
                if (serialNumber) {
                  this.resetWarnOrErrorMessage()
                  this.jump()
                } else {
                  const msg = '请扫原厂序列号'
                  this.updateWarnOrErrorMessage(msg, 'warn')
                }
              }
            }
            // 步骤：扫商品 PI
            else if (this.scanCurrentStep.code === 'pi') {
              // 是否是未识别的
              const unknownCode =
                !this.scanResult.success ||
                isNormal ||
                this.scanType === '69' ||
                this.scanType === 'CUSTOM_SERIALNUMBER'
              // 扫码类型为 69 或 自定义序列号
              if (unknownCode) {
                // 是否报错
                this.ifAnalysisError()
                // 序列号表单项
                const serialItem = this.searchFormItem(`${this.dataGoodsKeepingKey}.serialNumber`, [
                  this.diAreaColumns,
                  this.serialAreaColumns,
                  this.piAreaColumns,
                  this.otherAreaColumns,
                ])
                const epcItem = this.searchFormItem(`${this.dataGoodsKeepingKey}.epc`, [
                  this.diAreaColumns,
                  this.serialAreaColumns,
                  this.piAreaColumns,
                  this.otherAreaColumns,
                ])
                // 序列号表单项的值
                const serialValue = this.scanFormData[this.dataGoodsKeepingKey]?.serialNumber
                const epcValue = this.scanFormData[this.dataGoodsKeepingKey]?.epc
                // 单次扫码只赋值一次，要么自定义序列号赋值、要么原厂序列号赋值
                let ifScaned = false
                // 查找到序列号相关表单项
                if (!ifScaned && this.keepingCustomSerial && !epcValue) {
                  if (isNormal || this.scanCurrentResult.size === 0) {
                    scanData.set('epc', this.scanResult.origin)
                  }
                  // 更新表单
                  if (epcItem) {
                    this.updateScanFormDataForOther()
                    ifScaned = true
                  }
                }
                if (!ifScaned && this.keepingSerial && !serialValue) {
                  /*
                   * 是否将 origin 赋值给 serialNumber
                   * 可赋值的情况条件：
                   * 1. scanCurrentResult.size === 0 则什么都没解析到
                   * 2. isNormal=true 识别为普通码
                   */
                  if (isNormal || this.scanCurrentResult.size === 0) {
                    scanData.set('serialNumber', this.scanResult.origin)
                  }
                  // 更新表单
                  if (serialItem) {
                    this.updateScanFormDataForOther()
                    ifScaned = true
                  }
                }

                if (!ifScaned) {
                  this.updateWarnOrErrorMessage(this.analysisErrorMessage, 'error')
                }
              }
              // 更新商品 PI
              else {
                this.updateScanFormDataForOther()
              }
            }
          }
        }
      }
    },
    /**
     * 扫码流程中始终执行的函数
     *
     */
    async handlerFinally(initalData) {
      console.log('initalData: ', initalData)
      const detailId = objectUtil.getValueByPath(this.scanFormData, `${this.dataGoodsInfoKey}.id`)
      // 是否已调用过货位接口，优化多次调用货位接口的问题
      let isScanLocationApi = false
      if (detailId || this.scanType === 'CUSTOM_SERIALNUMBER') {
        // 反算货位、有效期至和带出注册证号、生产许可证号
        if (detailId && !isScanLocationApi) {
          isScanLocationApi = true
          await this.setPeriodOfValue() // 反算日期
          await this.calcOfValue()
        }
        // 调接口获取下方表格数据
        await this.queryTableDataList()
      }
      if (!isScanLocationApi) await this.setLocationOfValue() // 货位
    },
    /*
     * 识别不出条码（非自定义序列号、原厂序列号等）提示错误
     * !注意只在未识别时调用此方法才生效
     */
    ifAnalysisError() {
      // 是否是普通码
      const isNormal = this.analysisCodeType === '普通码' || this.scanType === '69'
      // 是否是未识别的
      const unknownCode =
        !this.scanResult.success ||
        isNormal ||
        this.scanType === '69' ||
        this.scanType === 'CUSTOM_SERIALNUMBER'

      // 未识别才继续执行
      if (!unknownCode) return

      // 判断是否有 DI 信息，如果无则重置
      this.isEmptyDi()

      // 序列号表单项
      const serialItem = this.searchFormItem(`${this.dataGoodsKeepingKey}.serialNumber`, [
        this.diAreaColumns,
        this.serialAreaColumns,
        this.piAreaColumns,
        this.otherAreaColumns,
      ])
      const epcItem = this.searchFormItem(`${this.dataGoodsKeepingKey}.epc`, [
        this.diAreaColumns,
        this.serialAreaColumns,
        this.piAreaColumns,
        this.otherAreaColumns,
      ])
      // 序列号表单项的值
      const serialValue = this.scanFormData[this.dataGoodsKeepingKey]?.serialNumber
      const epcValue = this.scanFormData[this.dataGoodsKeepingKey]?.epc
      //
      const onlySerial = serialItem && !epcItem && this.keepingSerial && serialValue
      const onlyEpc = epcItem && !serialItem && this.keepingCustomSerial && epcValue
      const isDouble =
        epcItem &&
        serialItem &&
        this.keepingSerial &&
        this.keepingCustomSerial &&
        serialValue &&
        epcValue

      // 不满足提示的条件则不提示
      if (!onlySerial && !onlyEpc && !isDouble) return

      // 清空序列号
      // if (onlyEpc || isDouble) objectUtil.setValueByPath(this.scanFormData, `${this.dataGoodsKeepingKey}.epc`, null)
      // if (onlySerial || isDouble) objectUtil.setValueByPath(this.scanFormData, `${this.dataGoodsKeepingKey}.serialNumber`, null)

      throw new Error(this.analysisErrorMessage)
    },
    /**
     * 获取扫码解析后返回的结果，最终得到扫码后的 scanResult 的值
     * scanResult 的数据结构：{ success: false, origin: null, codeType: null, data: new Map() }
     */
    getScanResult() {
      console.log('扫码获取到的码：', this.code)
      // 开始扫码解析
      const res = parseScanCodeUtils.scan(this.code, this.currentScanType)
      console.log('扫码解析 res: ', res)
      // 生成扫码解析结果展示的数据
      this.setAnalysisMessages(res)

      const gtin = res.data?.gtin
      const identity = res.data?.productIdent

      if (gtin || identity || this.scanType === 'CUSTOM_SERIALNUMBER') {
        this.resetScanResult()
      } else {
        console.log(this.scanResult)
        this.scanResult.data.delete('gtin')
        this.scanResult.data.delete('productIdent')
        // 单次扫码解析结果先清空
        this.scanCurrentResult.clear()
      }
      // 赋值 scanResult 非 data 属性的值
      this.scanResult.success = res.success // 解析是否识别到 GS1/MA/HIBC 等码的状态 true: 识别成功，false: 识别失败
      // 扫码类型为自定义序列号或普通码时，codeType 设为 ''
      this.scanResult.codeType = !(
        this.scanType === 'CUSTOM_SERIALNUMBER' || this.scanType === '69'
      )
        ? res.codeType
        : '' // 识别出的码类型，eg: GS1 码
      this.scanResult.origin = res.origin // 扫码获取到原始字符串
      this.scanResult.print = res.print // 扫码获取的打印条码的信息
      // 赋值 scanResult.data
      const { data: scanData } = this.scanResult
      for (const key in res.data) {
        const item = res.data[key]
        // 有值，且选择扫码类型为非自定义序列号或非普通码
        if (item?.value && !(this.scanType === 'CUSTOM_SERIALNUMBER' || this.scanType === '69')) {
          scanData.set(key, item.value)
          // 存储单次扫码解析结果
          this.scanCurrentResult.set(key, item.value)
        }
      }
      console.log('scanData:')
      this.consoleMap(scanData)
      console.log('scanCurrentResult:')
      this.consoleMap(this.scanCurrentResult)
      console.log('scanResult:')
      console.log(this.scanResult)

      // ------------------ 特殊逻辑: 替换 periodExpire 和 periodEnd ------------------ //
      // this.convertPeriodExpireToPeriodEnd();
      // ------------------ 特殊逻辑: 替换 periodExpire 和 periodEnd 结束 ------------------ //

      // 更新解析后识别出的码类型
      this.updateCodeType(this.scanResult.codeType)
    },
    // 反算货位、有效期至和带出注册证号、生产许可证号
    async calcOfValue() {
      await this.setRegistAndCertificOfValue() // 注册证号、生产许可证号
      // await this.setPeriodOfValue() // 反算日期
      await this.setLocationOfValue() // 货位
    },
    /**
     * 扫货位码的处理
     *
     * @param {string} [id] 商品id，未传入时取 this.scanFormData[this.dataGoodsInfoKey].id
     *
     */
    async setLocationOfValue() {
      const detailId = objectUtil.getValueByPath(this.scanFormData, `${this.dataGoodsInfoKey}.id`)
      const sid = this.scanFormData[this.dataGoodsInfoKey].id
      const scanid = this.scanTableData[0]?.[this.dataGoodsInfoKey]?.id || sid
      /*
       * 修复BUG #31249
       *
       * 推荐货位没有展示出来，原因是扫码类别选择“自定义序列号”时，this.scanFormData?.[this.dataGoodsInfoKey]?.id 无值
       * 所以此处取值 this.scanTableData[0]?.[this.dataGoodsInfoKey]?.id
       *
       */
      const id = !detailId ? scanid : sid
      const locationItem = this.searchFormItem('location')
      const { data: scanData } = this.scanResult
      let hasLocation = false // 是否配置了货位
      // 是否是推荐货位
      const warehouseId =
        locationItem?.parameter?.requestParameters?.params?.id ||
        this.scanTableDataInfoParam?.warehouseId
      if (locationItem?.isRecommend) {
        const goodsId = id
        const res = await this.$axios.get(this.locationScanInfoOfRecommend, {
          ...this.locationScanInfoOfRecommendParams,
          params: { ...this.locationScanInfoOfRecommendParams?.params, warehouseId, goodsId },
        })
        if (res.data?.code === 200) {
          const locationInfo = res.data?.data
          this.$set(locationItem, 'tip', locationInfo?.name)
          console.log(this.piAreaColumns)
          this.$forceUpdate() // 强制更新
        }
      }
      const { isHw } = this.getScanType()
      if (!isHw) return
      // 判断是否配置了货位的表单项
      if (locationItem) hasLocation = true
      if (!hasLocation) {
        // 没有配置货位
        this.updateWarnOrErrorMessage('没有配置货位', 'error')
        return
      }
      // 配置了货位, 带上仓库 warehouseId
      const location = await this.getLocationInfo(scanData.get('hw'), { warehouseId })
      if (location) {
        scanData.set('location', location)
        this.updateScanFormDataForOther()
      } else {
        this.updateWarnOrErrorMessage(this.locationErrorMessage, 'error')
      }
    },
    // 查找是否配置了注册证项
    findRegistrationItem() {
      const arr = [
        ...(this.diAreaColumns || []),
        ...(this.piAreaColumns || []),
        ...(this.otherAreaColumns || []),
      ]
      const result = arr.findIndex(
        (column) => column.code === `${this.dataGoodsKeepingKey}.registration`
      )

      return result > -1
    },
    /**
     * 根据获取到的生产日期的值，带出注册证号和生产许可证号的值
     *
     */
    setRegistAndCertificOfValue() {
      console.log('根据获取到的生产日期的值，带出注册证号和生产许可证号的值')
      return new Promise((resolve) => {
        const scanData = this.scanResult.data
        const period =
          this.scanFormData[this.dataGoodsKeepingKey]?.periodBegin ?? scanData.get('periodBegin')
        const goodsId = this.scanFormData[this.dataGoodsInfoKey].id
        const parameters = { params: { period, goodsId } }
        // 判断是否配置了注册证项
        const isRegistrationItem = this.findRegistrationItem()

        console.log('是否已配置注册证项: ', isRegistrationItem)
        if (period && goodsId && isRegistrationItem) {
          this.$axios
            .get('rest/ezscc/goods/selectCertsByPeriod', parameters)
            .then((res) => {
              if (res.data.code == 200) {
                const data = res.data.data

                // 判断表单内是否有注册证号和生产许可证号
                const arr = [
                  ...(this.diAreaColumns || []),
                  ...(this.piAreaColumns || []),
                  ...(this.otherAreaColumns || []),
                ]
                arr.forEach((column) => {
                  if (column.code === `${this.dataGoodsKeepingKey}.registration`) {
                    this.$set(
                      this.scanFormData[this.dataGoodsKeepingKey],
                      'registration',
                      data.registration
                    )
                  }
                  if (column.code === `${this.dataGoodsKeepingKey}.certification`) {
                    this.$set(
                      this.scanFormData[this.dataGoodsKeepingKey],
                      'certification',
                      data.certification
                    )
                  }
                })
              } else {
                if (res.data?.msg) {
                  this.$pgMessage.confirm({
                    title: '提示',
                    content: res.data.msg,
                  })
                }
              }
              resolve()
            })
            .catch((error) => {
              console.error(error)
              resolve()
            })
        } else {
          resolve()
        }
      })
    },
    /**
     * 根据策略反算结果，更新所有日期相关的值
     *
     */
    async setPeriodOfValue() {
      // 保质期推算获取到的日期
      const calc = this.calcPeriod()
      // 更新日期
      if (calc?.periodBegin) {
        objectUtil.setValueByPathForVue(
          this.scanFormData[this.dataGoodsKeepingKey],
          'periodBegin',
          calc.periodBegin,
          this
        )
      }
      if (calc?.periodEnd) {
        objectUtil.setValueByPathForVue(
          this.scanFormData[this.dataGoodsKeepingKey],
          'periodEnd',
          calc.periodEnd,
          this
        )
      }
    },
    /**
     * 替换 periodExpire 和 periodEnd
     * ！！！只有灵科系统需要替换
     * 涉及到的对象 this.scanFormData[this.dataGoodsKeepingKey] 和 this.scanResult.data
     */
    // convertPeriodExpireToPeriodEnd() {
    //   const { data: scanData } = this.scanResult
    //   const periodEnd = scanData.get('periodEnd')
    //   const periodExpire = scanData.get('periodExpire')

    //   // 判断是优联，还是灵科
    //   if (this.isLinkOfSystem) {
    //     if (periodExpire && !periodEnd) {
    //       const path = 'periodEnd'
    //       // 将 periodExpire 赋值给 periodEnd
    //       scanData.set(path, periodExpire)
    //       objectUtil.setValueByPathForVue(this.scanFormData[this.dataGoodsKeepingKey], path, periodExpire, this)
    //       if (this.scanFormData[this.dataGoodsKeepingKey]?.periodExpire) {
    //         delete this.scanFormData[this.dataGoodsKeepingKey].periodExpire
    //       }
    //     }

    //     // 删除属性 periodExpire
    //     if (periodExpire) scanData.delete('periodExpire')
    //   }
    // },
    /**
     * 反算日期
     *
     * 将现有的【按日】推算方式，细分为两个算法，假设商品的保质期是5年
     * 1、按日：
     * 1.1、正向推算：假设录入的生产日期=2021年3月3日，那么系统自动推算出的效期=2026年3月2日；
     * 1.2、逆向推算：假设录入的效期=2026年3月2日，那么系统自动推算出的生产日期=2021年3月3日；
     * 注：按月、按年以上面的逻辑实现
     *
     * 2、按日（失效日期）：
     * 2.1、正向推算：假设录入的生产日期=2021年3月3日，那么系统自动推算出的效期=2026年3月3日；
     * 2.2、逆向推算：假设录入的效期=2026年3月3日，那么系统自动推算出的生产日期=2021年3月3日；
     *
     * @returns {Object} { periodBegin, periodEnd }
     */
    calcPeriod() {
      // 使用单次扫码解析的结果，否则会出现 Bug#32513 的问题
      const scanData = this.scanCurrentResult
      // 扫码获取到的日期
      const scan = {
        periodBegin: scanData.get('periodBegin'),
        periodEnd: scanData.get('periodEnd'),
        periodExpire: scanData.get('periodExpire'),
      }
      // 效期(#34024)
      const _periodEnd = scan.periodExpire || scan.periodEnd

      let result = {
        periodBegin: scan.periodBegin,
        periodEnd: _periodEnd,
      }

      // 是否都不支持反算
      const disabledCalc = !this.isPositive && !this.isNegative
      // 判断生产日期和效期是否已经通过扫码获取到值，如果已经获取到值则不推算
      if (disabledCalc || (scan.periodBegin && _periodEnd)) {
        return result
      }
      // 确保参与反算日期的 periodEnd 的值是优先取 periodExpire 后的值
      if (_periodEnd) scan.periodEnd = _periodEnd
      // 商品日期相关
      const period = this.goodsInfo?.period ?? {}
      const options = {
        scan,
        unit: period.unit?.name,
        calc: period.calc?.name,
        life: period.life,
      }

      // 没有推算方式或保质期，则系统不进行推算
      if (!options.calc || !options.life) {
        if (!options.life) {
          console.warn('保质期数据不存在，不反算...')
          console.warn('options: ', options)
          console.warn('period: ', period)
          // this.$Message.info({
          //   content: '保质期数据不存在，不反算...',
          //   duration: 2,
          // })
        }
      } else {
        if (options.unit === '日' || !options.unit) {
          result = { ...result, ...this.dayCompute(options) }
        }
        if (options.unit === '月') {
          result = { ...result, ...this.mouthCompute(options) }
        }
        if (options.unit === '年') {
          result = { ...result, ...this.yearCompute(options) }
        }
      }

      console.log('反算日期的结果: ', result)
      return result
    },
    /**
     * 效期单位为 日 时推算方法
     *
     * @param {Object} options 配置
     * @param {Object} options.scan 扫码获取到日期 { periodBegin, periodEnd, periodExpire }
     * @param {String} options.calc 计算的类型：eg. 按月
     * @param {Number} options.life 保质期
     * @returns {Object} result 返回的结果 eg. { periodBegin, periodEnd, periodExpire }
     */
    dayCompute(options = {}) {
      const { scan, calc, life } = options
      const result = {}
      let model

      /********** 判断 calc 确定算法 **********/
      // 算法：按日（失效日期）unitOneDay = 0
      // 算法：按日 注 按月和按年默认以此算法反算日期 unitOneDay = oneDay
      const oneDay = 24 * 3600 * 1000
      const unitOneDay = /失效日期/g.test(calc) ? 0 : oneDay
      // 正向
      if (this.isPositive && scan?.periodBegin) {
        model = scan?.periodBegin
        const beginTime = new Date(model).getTime()
        const bgDate = new Date(beginTime + life * oneDay)
        if (calc === '按月') bgDate.setDate(bgDate.getDate()) // #35805, 优化日期反算
        const expireTime = bgDate.getTime() - unitOneDay
        result.periodBegin = model
        result.periodEnd = calc ? this.fomatDate(new Date(expireTime)) : null
      }
      // 反向
      else if (this.isNegative && (scan?.periodEnd || scan?.periodExpire)) {
        model = scan?.periodEnd || scan?.periodExpire
        const expireTime = new Date(model).getTime() + unitOneDay
        const bgDate = new Date(expireTime - life * oneDay)
        if (calc === '按月') bgDate.setDate(bgDate.getDate()) // #35805, 优化日期反算
        const beginTime = bgDate.getTime()
        result.periodBegin = this.fomatDate(new Date(beginTime))
        result.periodEnd = model
      }

      return result
    },
    /**
     * 效期单位为 月 的推算方法
     *
     * @param {Object} options 配置
     * @param {Object} options.scan 扫码获取到日期 { periodBegin, periodEnd, periodExpire }
     * @param {String} options.calc 计算的类型：eg. 按月
     * @param {Number} options.life 保质期
     * @returns {Object} result 返回的结果 eg. { periodEnd, periodExpire }
     */
    mouthCompute(options = {}) {
      const { scan, calc, life } = options
      const result = {}
      let model

      /********** 判断 calc 确定算法 **********/
      // 算法：按日（失效日期）unitOneDay = 0
      // 算法：按日 注 按月和按年默认以此算法反算日期 unitOneDay = oneDay
      const oneDay = 24 * 3600 * 1000
      const unitOneDay = /失效日期/g.test(calc) ? 0 : oneDay
      // 正向
      if (this.isPositive && scan?.periodBegin) {
        model = scan?.periodBegin
        const bgDate = new Date(model)
        const mouth = bgDate.getMonth() + life
        if (mouth > 11) {
          calc === '按月' ? bgDate.setMonth(mouth % 12, 1) : bgDate.setMonth(mouth % 12)
          bgDate.setFullYear(bgDate.getFullYear() + Math.floor(mouth / 12))
        } else {
          calc === '按月' ? bgDate.setMonth(mouth, 1) : bgDate.setMonth(mouth)
        }
        const expireTime = bgDate.getTime() - unitOneDay
        result.periodBegin = model
        result.periodEnd = calc ? this.fomatDate(new Date(expireTime)) : null
      }
      // 反向
      else if (this.isNegative && (scan?.periodEnd || scan?.periodExpire)) {
        model = scan?.periodEnd || scan?.periodExpire
        const expireTime = new Date(model).getTime() + unitOneDay
        const bgDate = new Date(expireTime)
        const mouth = bgDate.getMonth() - life
        if (mouth > 11) {
          calc === '按月' ? bgDate.setMonth(mouth % 12, 1) : bgDate.setMonth(mouth % 12)
          bgDate.setFullYear(bgDate.getFullYear() + Math.floor(mouth / 12))
        } else {
          calc === '按月' ? bgDate.setMonth(mouth, 1) : bgDate.setMonth(mouth)
        }
        const beginTime = bgDate.getTime()
        result.periodBegin = this.fomatDate(new Date(beginTime))
        result.periodEnd = model
      }

      return result
    },
    /**
     * 效期单位为 年 的推算方法
     *
     * @param {Object} options 配置
     * @param {Object} options.scan 扫码获取到日期 { periodBegin, periodEnd, periodExpire }
     * @param {String} options.calc 计算的类型：eg. 按年
     * @param {Number} options.life 保质期
     * @returns {Object} result 返回的结果 eg. { periodEnd, periodExpire }
     */
    yearCompute(options = {}) {
      const { scan, calc, life } = options
      const result = {}
      let model

      /********** 判断 calc 确定算法 **********/
      // 算法：按日（失效日期）unitOneDay = 0
      // 算法：按日 注 按月和按年默认以此算法反算日期 unitOneDay = oneDay
      const oneDay = 24 * 3600 * 1000
      const unitOneDay = /失效日期/g.test(calc) ? 0 : oneDay
      // 正向
      if (this.isPositive && scan?.periodBegin) {
        model = scan?.periodBegin
        const bgDate = new Date(model)
        bgDate.setFullYear(bgDate.getFullYear() + life)
        if (calc === '按月') bgDate.setDate(1)
        const expireTime = bgDate.getTime() - unitOneDay
        result.periodBegin = model
        result.periodEnd = calc ? this.fomatDate(new Date(expireTime)) : null
      }
      // 反向
      else if (this.isNegative && (scan?.periodEnd || scan?.periodExpire)) {
        model = scan?.periodEnd || scan?.periodExpire
        const expireTime = new Date(model).getTime() + unitOneDay
        const bgDate = new Date(expireTime)
        bgDate.setFullYear(bgDate.getFullYear() - life)
        if (calc === '按月') bgDate.setDate(1)
        const beginTime = bgDate.getTime()
        result.periodBegin = this.fomatDate(new Date(beginTime))
        result.periodEnd = model
      }

      return result
    },
    // 返回像 2019-08-12 样式的时间格式
    fomatDate(date) {
      if (date instanceof Date) {
        let year = date.getFullYear()
        let mouth = date.getMonth() + 1
        let day = date.getDate()
        mouth = mouth < 10 ? '0' + mouth : mouth
        day = day < 10 ? '0' + day : day
        return `${year}-${mouth}-${day}`
      } else {
        return date
      }
    },
    // 判断 scanFormData.goodsDetail 是否为空
    isEmptyDi() {
      const { isHw } = this.getScanType()
      // 产品优化：#31302，如果扫的货位且scanTableData.length > 0 则不判断 di 是否未扫
      if (isHw && this.scanTableData?.length > 0) return
      // 如果没有 goosDetail.id ，则认为没有 DI 信息
      const isEmpty = !objectUtil.getValueByPath(this.scanFormData, `${this.dataGoodsInfoKey}.id`)
      if (isEmpty && this.scanType !== 'CUSTOM_SERIALNUMBER') {
        this.resetScanFormData() // 未查询到 DI 信息时，报错需要给出提示信息并清空全部表单的内容
        this.resetScanResult() // 未查询到 DI 信息是，清空 scanResult #31794
        throw new Error(this.queryGoodsErrorMessage)
      }
    },
    // 是否忽略当前步骤，并且更新当前步骤。返回值 false: 跳过
    skip(goods) {
      let isSkip = false
      if (!this.scanCurrentStep.skip) {
        isSkip = false // 不跳过当前步骤
      } else {
        // 根据表达式结果，判断是否跳过
        isSkip = !templateUtil.compileData(`{{${this.scanCurrentStep.skip}}}`, {
          data: this.scanFormData,
        })
        console.log('当前步骤是否可跳过：', isSkip)
      }

      if (isSkip) {
        this.jump()
        this.skip()
        return
      }

      // 根据获取到的 goods.keepingSerial 和 goods.keepingCustomSerial 判断跳转至哪一步
      if (!goods) return
      if (
        !(
          goods.keepingSerial ||
          goods.keepingCustomSerial ||
          goods.keepingRfidSerial ||
          goods.keepingExclusiveSerial
        )
      ) {
        this.jump({ step: 'pi' })
      } else {
        const compnentRange = [this.serialAreaColumns, this.diAreaColumns]
        // 查找自定义序列号或原厂序列号表单项是否已配置
        const epcItem = this.searchFormItem(`${this.dataGoodsKeepingKey}.epc`, compnentRange)
        const serialItem = this.searchFormI
        const isCustomSerial =
          goods.keepingCustomSerial || goods.keepingRfidSerial || goods.keepingExclusiveSerial

        if (epcItem && isCustomSerial && !this.scanFormData[this.dataGoodsKeepingKey]?.epc) {
          const step = this.goodInfoTableColumnDefUrl ? 'pi' : 'epc'
          this.jump({ step })
          // scanTable 不提示
          if (!this.goodInfoTableColumnDefUrl)
            this.updateWarnOrErrorMessage('请扫自定义序列号', 'warn')
        } else if (
          serialItem &&
          goods.keepingSerial &&
          !this.scanFormData[this.dataGoodsKeepingKey]?.serialNumber
        ) {
          const step = this.goodInfoTableColumnDefUrl ? 'pi' : 'sn'
          this.jump({ step })
          // scanTable 不提示
          if (!this.goodInfoTableColumnDefUrl)
            this.updateWarnOrErrorMessage('请扫原厂序列号', 'warn')
        } else {
          this.jump({ step: 'pi' })
        }
      }
    },
    /**
     * 跳转切换步骤
     *
     * @param {object} [params={}]
     * @param {boolean} params.begin 为 true 返回至第一步
     * @param {boolean} params.last 为 true 跳转最后一步
     * @param {string} params.step 指定的步骤 值为步骤的 code eg. {code: 'sn', name: '扫码获取商品的原厂序列号', skip: 'data.goodsDetail.keepingSerial'}
     */
    jump(params = {}) {
      const { begin, last, step } = params
      // 跳转至 DI（第一步）
      if (begin) {
        const first = this.allStep[0]
        this.scanCurrentStep = first
        return
      }
      // 跳转至 PI（最后一步）
      if (last) {
        const len = this.allStep.length
        const end = this.allStep[len - 1]
        this.scanCurrentStep = end
        return
      }
      // 跳转至指定步骤
      if (step) {
        let curIndex = -1
        const len = this.allStep.length
        for (let index = 0; index < len; index++) {
          const cur = this.allStep[index]
          if (step === cur.code) {
            curIndex = index
            // 跳转至
            this.scanCurrentStep = cur
            break
          }
        }
        // 没有匹配到指定步骤，则跳转至下一步
        if (curIndex === -1) this.jump()

        // 提示下一步扫码动作
        this.showMessageByStep()
        return
      }
      // 跳转至下一步
      if (!(begin || last || step)) {
        const len = this.allStep.length - 1 // 最后一步时忽略
        for (let index = 0; index < len; index++) {
          const step = this.allStep[index]
          if (step.code === this.scanCurrentStep.code) {
            // 跳转至下一步
            const next = this.allStep[index + 1]
            this.scanCurrentStep = next
            break
          }
        }

        // 提示下一步扫码动作
        this.showMessageByStep()
        return
      }
    },
    // 根据步骤显示提示信息
    showMessageByStep() {
      const curStep = this.scanCurrentStep
      let msg
      if (typeof curStep.message === 'string') {
        msg = curStep.message
      } else {
        if (curStep.message?.[curStep.code]) {
          msg = curStep.message?.[curStep.code]
        } else {
          msg =
            curStep.code === 'sn'
              ? '请扫原厂序列号'
              : curStep.code === 'epc'
              ? '请扫自定义序列号'
              : null
        }
      }

      if (msg) this.updateWarnOrErrorMessage(msg, 'warn')
    },
    // 重置 scanResult
    resetScanResult() {
      this.scanResult.codeType = null
      this.scanResult.origin = null
      this.scanResult.print = null
      this.scanResult.success = false
      this.scanResult.data.clear()
      // 单次扫码结果
      this.scanCurrentResult.clear()
    },
    // 重置 scanFormData
    resetScanFormData() {
      // 焦点移至扫码区输入框
      this.$refs.areaScanInput.focus()

      // 未锁定
      if (!this.isLock) {
        this.scanFormData = {
          [this.dataGoodsInfoKey]: {},
          [this.dataGoodsKeepingKey]: { epc: null, serialNumber: null },
          [this.dataGoodsPreserveKey]: {},
        }
        // 修复 #31643，验收结论确认扫码之后，没有恢复默认值
        objectUtil.setValueByPathForVue(
          this.scanFormData,
          this.acceptResultKey,
          this.acceptResultDefault,
          this
        )
        // 先清空
        // objectUtil.setValueByPathForVue(this.scanFormData, this.dataGoodsInfoKey, {}, this)
        // objectUtil.setValueByPathForVue(this.scanFormData, this.dataGoodsKeepingKey, { epc: null, serialNumber: null }, this)
        // objectUtil.setValueByPathForVue(this.scanFormData, this.dataGoodsPreserveKey, {}, this)
        // 跳转至第一步 DI
        this.jump({ begin: true })
      }
      // 连续扫码模式，且已锁定
      else if (this.mode === 'series') {
        let msg
        const firstStep = this.allStep[0]
        // 是否配置了序列号的表单项
        const epcItem = this.searchFormItem(`${this.dataGoodsKeepingKey}.epc`, [
          this.serialAreaColumns,
        ])
        const serialItem = this.searchFormItem(`${this.dataGoodsKeepingKey}.serialNumber`, [
          this.serialAreaColumns,
        ])
        // 跳转至
        if (epcItem && this.keepingCustomSerial) {
          this.jump({ step: 'epc' })
          msg = typeof firstStep.message === 'string' ? firstStep.message : firstStep.message?.epc
        } else if (serialItem && this.keepingSerial) {
          this.jump({ step: 'sn' })
          msg = typeof firstStep.message === 'string' ? firstStep.message : firstStep.message?.sn
        }
        // 提示下一步扫码动作
        if (msg) this.updateWarnOrErrorMessage(msg, 'warn')

        // 序列号管理商品，只清空序列号
        if (this.keepingCustomSerial)
          objectUtil.setValueByPath(this.scanFormData, `${this.dataGoodsKeepingKey}.epc`, null)
        if (this.keepingSerial)
          objectUtil.setValueByPath(
            this.scanFormData,
            `${this.dataGoodsKeepingKey}.serialNumber`,
            null
          )
      }
    },
    // 重置错误提示
    resetWarnOrErrorMessage() {
      if (this.warnOrErrorMessage) {
        this.warnOrErrorMessage = ''
        this.warnOrErrorMessageType = ''
      }
    },
    // 更新警告或错误信息和类别
    updateWarnOrErrorMessage(info, type) {
      if (!type || (type !== 'error' && type !== 'warn')) {
        throw new Error('type 不可为空！且必须是 warn 或 error')
      }
      this.warnOrErrorMessage = info || '扫码出现未知错误'
      this.warnOrErrorMessageType = type
    },
    updateCodeType(type) {
      this.analysisCodeType = type || '普通码'
    },
    /**
     * 更新表单数据(只用于扫GS1、HIBC、MA码)
     * @param {object} item 商品信息
     */
    updateScanFormData({ item }) {
      // 锁定时不更新
      if (this.isLock) return
      // 遍历解析结果，更新 scanFormData
      const scanData = this.scanResult.data
      for (let [key, val] of scanData) {
        if (val) {
          // #34024
          if (key === 'periodEnd') {
            this.$set(
              this.scanFormData[this.dataGoodsKeepingKey],
              key,
              scanData.get('periodExpire') || val
            )
            continue
          }
          this.$set(this.scanFormData[this.dataGoodsKeepingKey], key, val)
        }
      }
      // 遍历商品信息，更新 scanFormData
      for (let key in item) {
        let val = item[key]
        if (key === 'barcodeAmount') {
          // 修复BUG#31305: 商品开启序列号管理后，数量设为 1
          const isSerial =
            item.keepingSerial ||
            item.keepingCustomSerial ||
            item.keepingRfidSerial ||
            item.keepingExclusiveSerial

          // 数量取值判断标准
          const amountChoose = item?.amountChoose ?? 'DEFAULT'
          // 包装规格数量
          const barcodeAmount = +item?.barcodeAmount || 0
          // 辅助单位数量
          const unitOtherAmount = +item?.unitOtherItem?.ratio?.dividend || 0
          // 包装规格或辅助单位数量
          const otherAmount = amountChoose === 'AUXILIARY' ? unitOtherAmount : barcodeAmount

          const num = isSerial ? 1 : otherAmount || 1
          this.$set(this.scanFormData, `${this.dataAmountKey}`, num)
        }
        if (val || val != null) this.$set(this.scanFormData[this.dataGoodsInfoKey], key, val)
      }
      // 优联
      if (!this.isLinkOfSystem) {
        // 将接口返回的数据 item.preserve 赋值给 this.scanFormData.preserve
        this.scanFormData[this.dataGoodsPreserveKey] = item[this.dataGoodsPreserveKey] || null
      }
    },
    /**
     * 更新表单数据（只用于扫二段式、三段式GS1、原厂序列号、普通码）
     * @param {object} item 商品信息
     */
    updateScanFormDataForOther() {
      const { data: scanData } = this.scanResult
      for (let [key] of scanData) {
        const val = scanData.get(key)
        if (key === `${this.dataAmountKey}`) continue
        if (val) {
          if (key === 'location') {
            this.$set(this.scanFormData, key, val)
            continue
          }
          if (!this.isLock || /^serialNumber$/.test(key) || /^epc$/.test(key)) {
            // 修复 Bugfix #31061: 未开启序列号管理，且解析的商品的原厂序列号或自定义序列号的字段有值时，则不更新至 scanFormData
            if (
              (!this.keepingSerial && /^serialNumber$/.test(key)) ||
              (!this.keepingCustomSerial && /^epc$/.test(key))
            ) {
              continue
            }
            // #34024
            if (key === 'periodEnd') {
              this.$set(
                this.scanFormData[this.dataGoodsKeepingKey],
                key,
                scanData.get('periodExpire') || val
              )
              continue
            }

            this.$set(this.scanFormData[this.dataGoodsKeepingKey], key, val)
          }
        }
      }
    },
    /********** 组件部分 **********/
    // 给自定义序列号或原厂序列号赋值
    setSerialAndEpc(path) {
      console.log('component code: ', path)
      this.$set(this.scanFormData, path, this.code)
    },
    // 监听表单组件的事件 on-change，将焦点移入扫码输入框
    async formItemOnChange(val, code) {
      console.log('formItemOnChange', val, code)
      const scanData = this.scanCurrentResult
      // 是否是灵科
      const isLink = this.dataGoodsKeepingKey === 'goodsStore'
      // 目前只监听：验收结论、注册证号和生产许可证号的值变化
      const arr = [
        isLink ? 'acceptStatus' : 'attrs.valueEnum.acceptResult',
        `${this.dataGoodsKeepingKey}.registration`,
        `${this.dataGoodsKeepingKey}.certification`,
      ]
      if (arr.includes(code)) this.$refs?.areaScanInput?.focus()

      // 反算日期
      if (code === `${this.dataGoodsKeepingKey}.periodBegin`) {
        scanData.set('periodBegin', val)
        scanData.set('periodEnd', null) // 重置 scanData.periodEnd
        scanData.set('periodExpire', null) // 重置 scanData.periodExpire
        await this.setPeriodOfValue() // 反算日期
        // 根据获取到的生产日期的值，带出注册证号和生产许可证号的值
        await this.setRegistAndCertificOfValue()
      }
      if (code === `${this.dataGoodsKeepingKey}.periodEnd`) {
        scanData.set('periodBegin', null) // 重置 scanData.periodBegin
        scanData.set('periodExpire', null) // 重置 scanData.periodExpire
        scanData.set('periodEnd', val)
        await this.setPeriodOfValue() // 反算日期
      }

      // 手动修改批号和原厂序列号后，同步修改 scanCurrentResult.data 和 scanResult.data 上的值
      if (code === `${this.dataGoodsKeepingKey}.batchNumber`) {
        this.scanResult.data.set('batchNumber', val)
        scanData.set('batchNumber', val)
      }
      if (code === `${this.dataGoodsKeepingKey}.serialNumber`) {
        this.scanResult.data.set('serialNumber', val)
        scanData.set('serialNumber', val)
      }
      // 数量
      // this.updateAmount()
    },
    /** @name 更新scanFormData.amount,项目中可能amount的字段不一致 */
    updateAmount(amountKey = this.dataAmountKey) {
      const scanData = this.scanCurrentResult
      // 是否开启序列号，如果开启则序列号为必填
      const ifSerial = scanUtils.ifSerial(
        this.scanFormData,
        `${this.dataGoodsInfoKey}.keepingSerial`
      )
      // 数量取值判断标准
      const amountChoose = this.goodsInfo?.amountChoose ?? 'DEFAULT'
      // 扫到的条码上的数量
      const codeAmount = +scanData.get('amount') || 0
      // 商品信息或扫码组件内输入的数量
      const infoAmount = +this.goodsInfo?.[amountKey] || +this.scanFormData?.[amountKey] || 0
      // 包装规格数量
      const barcodeAmount = +this.goodsInfo?.barcodeAmount || 0
      // 辅助单位数量
      const unitOtherAmount = +this.goodsInfo?.unitOtherItem?.ratio?.dividend || 0
      // 包装规格或辅助单位数量
      const otherAmount = amountChoose === 'AUXILIARY' ? unitOtherAmount : barcodeAmount
      // 数量
      const amount = ifSerial ? 1 : codeAmount || otherAmount || infoAmount || 1

      if (this.scanCurrentStep !== 'di' && !codeAmount) return

      objectUtil.setValueByPathForVue(this.scanFormData, amountKey, amount, this)
    },
    // 监听表单组件的事件 on-keyup
    formSerialOnKeyup(evt, code) {
      const value = evt.target.value
      // 清空
      objectUtil.setValueByPath(this.scanFormData, code, '')
      // 序列号表单项
      evt.target.select()
      evt.target.focus()
      // 赋值
      if (value) {
        const { data: scanData } = this.scanResult
        const path = code.substring(code.lastIndexOf('.') + 1)

        scanData.set(path, value)
        objectUtil.setValueByPath(this.scanFormData, code, value)

        const epcItem = this.searchFormItem(`${this.dataGoodsKeepingKey}.epc`, [
          this.serialAreaColumns,
        ])
        const epcValue = this.scanFormData[this.dataGoodsKeepingKey]?.epc
        const serialItem = this.searchFormItem(`${this.dataGoodsKeepingKey}.serialNumber`, [
          this.serialAreaColumns,
        ])
        const serialValue = this.scanFormData[this.dataGoodsKeepingKey]?.serialNumber

        if (/\.epc$/.test(code) && epcItem && epcValue) {
          if (serialItem && !serialValue) {
            this.updateWarnOrErrorMessage('请扫原厂序列号', 'warn')
            this.jump({ step: 'sn' })
          } else if (!this.isLock) {
            this.resetWarnOrErrorMessage()
            this.jump({ step: 'pi' })
          }
        }
        if (/\.serialNumber$/.test(code) && serialItem && serialValue && !this.isLock) {
          this.resetWarnOrErrorMessage()
          this.jump({ step: 'pi' })
        }

        // 已锁定
        if (this.isLock) {
          // 判断是否是非序列号商品
          this.noSerialManage()
          // 自动提交
          this.onAutoConfirm()
        }
      }
    },
    // 监听表单组件的事件 on-Focus
    formSerialOnFocus(evt, code) {
      const isSerial = /\.serialNumber$/.test(code) || /\.epc$/.test(code)
      if (isSerial) {
        evt.target.value = null
        objectUtil.setValueByPath(this.scanFormData, code, null)
      }
    },
    // 生成扫码表单初始值
    setAreaColumns(arr = ['diAreaColumns', 'piAreaColumns', 'otherAreaColumns']) {
      const regAndCertArr = [
        `${this.dataGoodsKeepingKey}.registration`,
        `${this.dataGoodsKeepingKey}.certification`,
      ]
      arr.forEach((item) => {
        this[item]?.forEach((column, index) => {
          // 忽略注册证号、生产许可证号的表单项
          if (!regAndCertArr.includes(column.code)) {
            const urlQuery = column.parameter?.urlQuery
            const method = (column.parameter?.requestMethod ?? 'get').toLowerCase()
            // 配置时注意，GET 请求时，需要配置到 column.parameter.requestParameters.params 中
            const params = { ...column.parameter?.requestParameters }
            const labelKey = column.props?.labelKey ?? 'label'
            const valueKey = column.props?.valueKey ?? 'value'
            let options = []
            if (urlQuery) {
              this.$axios[method](urlQuery, params).then((res) => {
                res?.data?.data?.forEach((cur) => {
                  if (cur)
                    options.push({ ...cur, [labelKey]: cur[labelKey], [valueKey]: cur[valueKey] })
                })
                this.$set(this[item], index, { ...column, props: { ...column.props, options } })
                // 初始化验收结论为合格
                if (
                  column.code === 'attrs.valueEnum.acceptResult' ||
                  column.code === 'acceptStatus'
                ) {
                  objectUtil.setValueByPath(
                    this.scanFormData,
                    column.code,
                    this.acceptResultDefault
                  )
                }
              })
            }
          }
        })
      })
    },
    setAreaColumnsForRegAndCert(
      goods,
      arr = ['diAreaColumns', 'piAreaColumns', 'otherAreaColumns']
    ) {
      const regAndCertArr = [
        `${this.dataGoodsKeepingKey}.registration`,
        `${this.dataGoodsKeepingKey}.certification`,
      ]
      arr.forEach((item) => {
        this[item]?.forEach((column, index) => {
          // 处理注册证号、生产许可证号的表单项
          if (regAndCertArr.includes(column.code)) {
            const goodsId = goods ? goods.id : this.scanFormData[this.dataGoodsInfoKey].id
            this.$set(this[item], index, { ...column, props: { ...column.props, goodsId } })
          }
        })
      })
    },
    // 判断确认提交按钮是否可点击
    canConfirm() {
      let isConfirm = true
      const requiredArr = [this.piAreaColumns, this.otherAreaColumns]
      requiredArr.forEach((arr) => {
        if (arr?.length) {
          arr.forEach((item) => {
            if (item.props?.required) {
              const val = objectUtil.getValueByPath(this.scanFormData, item.code)
              if (!val && val !== 0 && val !== false) isConfirm = false
            }
          })
        }
      })
      return !this.isSave && isConfirm
    },
    // 重置状态，例如：确认按钮、保存按钮和错误提示
    reset() {
      this.resetWarnOrErrorMessage()
      this.code = ''
      this.inputValue = ''
      this.selectionIds = {}
      this.medicalData = null
    },
    // 卸载
    uninstall() {},
    // 计算弹窗的宽度
    calcDrawerWidth: lodashUtils.debounce(function () {
      if (this.drawerWidth) return
      console.log('计算弹窗的宽度')
      // 全屏宽度
      const _width = document.body?.offsetWidth ?? 0

      this.drawerWidth = this.width === '100%' ? `${_width - this.offset}px` : this.width
      console.log('全屏的宽度: ', _width)
      console.log('Props.width: ', this.width)
      console.log('抽屉 Drawer 的宽度: ', this.drawerWidth)
    }, 100),
    // 计算表格的高度上限
    calcTableHeight: lodashUtils.debounce(function (defaultTableHeight = 0) {
      const _self = this
      if (_self.tableHeight) return
      console.log('计算表格的高度上限')
      // 偏移量 增加: < 0 | 减少: > 0
      const offset = 12
      // 全屏高度
      const _height = document.body.offsetHeight
      // 工具栏 Dom
      const toolbarEl = _self.$refs.scanToolbar
      // 工具栏的高度
      const toolbarHeight = toolbarEl.offsetHeight || 35
      // Modal Header 的高度
      const modalHeadHeight = 65

      // 抽屉打开时，获取的扫码区域高度有误，延迟一下避免此 bug
      setTimeout(() => {
        // 扫码区域 Dom
        const scanEl = _self.$refs.scanArea
        // 扫码区域的高度
        const scanHeight = scanEl.offsetHeight || defaultTableHeight

        _self.tableHeight = _height - offset - (scanHeight + toolbarHeight + modalHeadHeight)

        console.log('表格的高度: ', _self.tableHeight)
        console.log('扫码区域的高度: ', scanHeight)
        console.log('工具栏的高度: ', toolbarHeight)
        console.log('全屏的高度: ', _height)
      }, 500)
    }, 100),
    /** @name 校验是否已写入序列号 */
    checkInputSerial() {
      const serialNumber = objectUtil.getValueByPath(
        this.scanFormData,
        `${this.dataGoodsKeepingKey}.serialNumber`
      )

      return !!serialNumber
    },
    /** @name 请求开启商品的序列号管理 */
    async openGoodsKeepingSerial() {
      // #6553,根据系统策略判断，是否自动设置商品档案的序列号管理
      if (!this.isAutoSerial) return
      const goodsData = await this.getAdvanceOfGoods()
      const res = await this.$axios
        .post('/rest/ezscc/scan/submitGoods', { ...goodsData?.goods, keepingSerial: true })
        .catch((error) => {
          console.error(error.message)
        })
      if (res.data?.code !== 200) throw new Error(res.data?.msg)

      this.updateWarnOrErrorMessage(
        '序列号字段有值，但商品档案并未开启序列号管理，已为您自动开启',
        'warn'
      )
    },
    /** @name 请求获取商品的可编辑实体 */
    async getAdvanceOfGoods(goodsId) {
      const id =
        goodsId || objectUtil.getValueByPath(this.scanFormData, `${this.dataGoodsInfoKey}.id`)
      const res = await this.$axios
        .get(`rest/main/goods/goods/getAdvance?id=${id}`)
        .catch((error) => {
          console.error(error.message)
        })
      if (res.data?.errors) throw new Error(res.data.errors?.[0]?.message ?? '发生异常')
      if (res.data?.code !== 200) throw new Error(res.data?.msg)
      return res?.data?.data ?? {}
    },
    /**
     * 校验必要项
     *
     * @param {Object} options 配置
     * @param {String} options.status 状态 可选值：提交 submit | 锁定 lock
     */
    async validateRequired(options = { status: 'submit' }) {
      // #6805, 第二次请求获取商品DI信息成功后，禁止必填校验
      if (this.disabledValidRequired) {
        // 重置
        this.disabledValidRequired = false
        return
      }
      const { status } = options
      const fd = this.scanFormData
      console.log('******************** 校验必要项 ********************')
      console.log('扫码识别的商品的条码: ', this.code)
      console.log('确认提交时的 scanFormData: ', fd)
      console.log('******************** End ********************')
      let emptyItem = [] // 缺失的项
      //
      const columns = [this.diAreaColumns, this.piAreaColumns, this.otherAreaColumns]
      // 找到必填项，存储它的 code
      const checkArr = []

      // 是否开启序列号，如果开启则序列号为必填
      // #6553, 根据策略判断是否需要校验序列号的必填性
      const ifSerial = scanUtils.ifSerial(
        this.scanFormData,
        `${this.dataGoodsInfoKey}.keepingSerial`
      )

      if (ifSerial) {
        checkArr.push('serialNumber')
      } else {
        if (this.checkInputSerial()) {
          await this.openGoodsKeepingSerial()
        }
      }

      columns.forEach((column) => {
        if (column?.length) {
          column.forEach((item) => {
            if (item.props?.required) checkArr.push(item)
          })
        }
      })
      // 获取商品 id
      const detailId = objectUtil.getValueByPath(this.scanFormData, `${this.dataGoodsInfoKey}.id`)
      // 遍历 checkArr，根据 code 取值，如果无值则缺失必填项
      checkArr.forEach(({ code, name }) => {
        const val = objectUtil.getValueByPath(this.scanFormData, code)

        if (lodashUtils.isNone(val) && code !== `${this.dataGoodsKeepingKey}.batchNumber`) {
          emptyItem.push(name)
        }
        // 扫码类别选择自定义序列号，不校验 DI 信息的必填项
        if (!detailId && this.scanType !== 'CUSTOM_SERIALNUMBER') emptyItem.push('商品 DI 信息')
      })

      // 确认提交时校验序列号
      if (status === 'submit') {
        const { success: serialValidSuccess, messsage } = this.validateRequiredSerial()
        if (!serialValidSuccess) return { success: false, message: `请扫${messsage || '序列号'}` }
      }

      // 去重
      emptyItem = [...new Set(emptyItem)]

      const success = !emptyItem.length
      return { success, message: `缺失必填项: ${emptyItem.join('、 ')}` }
    },
    // 校验序列号是否必填
    validateRequiredSerial() {
      const result = { success: true, message: '' }

      console.log('serialAreaColumns: ', this.serialAreaColumns)
      if (this.serialAreaColumns) {
        for (let n = 0; n < this.serialAreaColumns.length; n++) {
          const column = this.serialAreaColumns[n]
          const val = objectUtil.getValueByPath(this.scanFormData, column.code)
          if (column.props?.required === true && val == null) {
            if (
              (this.keepingSerial && /\.serialNumber$/.test(column.code)) ||
              (this.keepingCustomSerial && /\.epc$/.test(column.code))
            ) {
              result.success = false
              result.message = column.name
              break
            }
          }
        }
      }

      return result
    },
    // 判断扫码模式
    getScanType() {
      const result = this.scanResult
      const isMa = result.codeType ? /^MA/i.test(result.codeType) : false // MA
      const isHibc = result.codeType ? /^HIBC/i.test(result.codeType) : false // HIBC
      const isGS1 = result.codeType ? /^GS1/i.test(result.codeType) : false // GS1
      const isHw = result.codeType ? /^HW/i.test(result.codeType) : false // 货位

      return { isMa, isHibc, isGS1, isHw }
    },
    // 查找表单项的元素
    searchFormItem(
      propName,
      arr = [this.diAreaColumns, this.piAreaColumns, this.otherAreaColumns]
    ) {
      if (!propName) throw new Error('请传入参数 propName，eg. goodsDetail.name')
      let searchItem
      const columns = arr || []
      const regx = new RegExp(propName)

      for (let n = 0; n < columns.length; n++) {
        const column = columns[n] || []
        for (let m = 0; m < column.length; m++) {
          const item = column[m]
          if (regx.test(item.code)) {
            searchItem = item
            searchItem.nIndex = m
            break
          }
        }
        if (searchItem) break
      }

      return searchItem
    },
    // 查询表格数据
    async getTableData() {
      console.log('requestTableDataParameters: ', this.requestTableDataParameters)
      try {
        if (this.tableDataUrl) {
          const dataItemKey = this.requestTableDataParameters?.dataItemKey
          const res = await this.$axios
            .post(this.tableDataUrl, { ...this.requestTableDataParameters })
            .catch((error) => {
              console.error(error?.message)
            })
          if (res.data?.code !== 200) {
            throw new Error(res.data?.msg)
          }

          //
          const _data = dataItemKey ? res.data?.data?.[dataItemKey] : res.data?.data ?? []
          console.log('查询表格数据: ', _data)

          return _data
        }
      } catch (error) {
        this.updateWarnOrErrorMessage(error?.message, 'error')
      }
    },
    // 扫码查询表格数据信息
    async queryTableDataInfo(params = {}) {
      if (this.tableDataInfoUrl) {
        // 获取到的商品信息
        let goods = {}
        // 清空原 scanFormData
        this.resetScanFormData()
        // 请求接口获取商品信息
        const res = await this.$axios
          .post(this.tableDataInfoUrl, { ...params, ...this.tableDataInfoParameters })
          .catch((error) => {
            console.error(error?.message)
          })
        if (res.data?.code !== 200) throw new Error(res.data?.msg)
        if (lodashUtils.isEmpty(res.data?.data)) {
          throw new Error(this.queryGoodsErrorMessage)
        } else {
          // 查询到商品时，重置提示信息
          this.resetWarnOrErrorMessage()
        }

        // 判断是否是多规格/型号
        if (Array.isArray(res.data?.data) && res.data?.data?.length > 1) {
          this.medicalData = res.data?.data // 修复#31672，此处不要冻结对象（性能优化效果也不明显）
          this.isSelectModel = true // 如果有多个规格/型号，则弹出选择框
          goods = await this.waitSelectModel() // 等待选中规格/型号后继续执行
        } else {
          goods = res.data.data[0]
        }

        // 根据获取到的 goods ，带出注册证号和生产许可证号的表单可选项
        if (goods) this.setAreaColumnsForRegAndCert(goods)

        // 处理药械闪加相关数据
        await this.handleFlashMedicalData(goods)

        return goods
      }
    },
    // 药械闪加相关数据
    async handleFlashMedicalData(goods = {}) {
      const url = this.searchMedicalListUrl
      const params = this.searchMedicalListOfParams
      const code = goods?.code
      const parameters = { ...params }

      if (code) parameters.codes = [code]

      console.log('药械闪加相关数据 code: ', code)
      let selectGoods
      if (!this.disabledScanSearchMedicalList && url && code) {
        const res = await this.$axios.post(url, { parameters })

        if (!this.$cfn.ajax1.isOK(res, this)) return

        const selectData = res.data?.data

        if (lodashUtils.isEmpty(selectData)) {
          this.$Message.error('没有符合添加条件的商品')
          return
        }

        selectGoods = selectData?.[0] ?? {}
      } else {
        selectGoods = goods
      }

      // 默认加上数量 1
      selectGoods[this.dataAmountKey] = selectGoods[this.dataAmountKey] || 1

      console.log('扫码添加 已选中的添加商品：', selectGoods)
      this.$emit('on-change', { infos: selectGoods })

      // 重置(bug#37305)
      this.reset()
    },
    // 判断 scanTableData.length 是否为 0，如果是则给出错误提示。适用于需求#5797
    ifEmptyForScanTableData(errorMessage) {
      const data = this.scanTableData
      if (lodashUtils.isEmpty(data)) {
        this.updateWarnOrErrorMessage(errorMessage ?? '没有匹配到任务或库存', 'error')
      }
    },
    // 扫码后查询表格数据
    async queryTableDataList(params = {}, row = null) {
      console.log('扫码后查询表格数据...')
      // 一般只会在扫码组件: scanTable 配置此 props.goodInfoTableColumnDefUrl
      if (!this.goodInfoTableColumnDefUrl) return
      const scanTableDataInfoUrl = this.scanTableDataInfoUrl
      // 根据 di 表单项获取参数
      const _params = this.diAreaColumns.reduce((prev, column) => {
        // 获取表单项的值，有值则赋值
        const val = objectUtil.getValueByPath(this.scanFormData, column.code)
        objectUtil.setValueByPath(prev, column.code, val)

        return { ...prev }
      }, {})
      // 获取扫码解析项的值，有值则赋值
      const { data: scanData } = this.scanResult
      // 扫码类别为自定义序列号时
      if (!scanData.get('epc') && this.scanType === 'CUSTOM_SERIALNUMBER') {
        scanData.set('epc', this.scanResult.origin)
      }

      const _paramsExtend = {
        periodBegin: scanData.get('periodBegin') || row?.[this.dataGoodsKeepingKey]?.periodBegin,
        periodEnd: scanData.get('periodEnd') || row?.[this.dataGoodsKeepingKey]?.periodEnd,
      }
      // #34036，优先使用失效日期（17）来匹配库存，如果失效日期（17）和有效期至（12）都有值，则使用失效日期（17）来匹配
      const periodExpire =
        scanData.get('periodExpire') || row?.[this.dataGoodsKeepingKey]?.periodExpire
      if (periodExpire) {
        objectUtil.setValueByPath(_paramsExtend, 'periodEnd', periodExpire)
      }

      if (row) this.goodsInfo = objectUtil.clone(row)
      const goodsInfo = this.goodsInfo
      // 是否开启序列号管理
      const isSerial =
        this.scanType === 'CUSTOM_SERIALNUMBER' ||
        goodsInfo.keepingSerial ||
        goodsInfo.keepingCustomSerial ||
        goodsInfo.keepingRfidSerial ||
        goodsInfo.keepingExclusiveSerial
      // 如果开启了序列号管理，并配置了表单则赋值
      if (isSerial) {
        const _item = _params[this.dataGoodsKeepingKey] ?? {}
        // 配置了原厂序列号
        if (Object.prototype.hasOwnProperty.call(_item, 'serialNumber')) {
          _paramsExtend.serialNumber = scanData.get('serialNumber')
        }
        // 配置了自定义序列号，Bug#30986
        if (
          this.scanType === 'CUSTOM_SERIALNUMBER' ||
          Object.prototype.hasOwnProperty.call(_item, 'epc')
        ) {
          _paramsExtend.epc = scanData.get('epc')
        }
      }
      // 判断货位是否是可录入的，如果是可录入的，则不将货位装入 _paramsExtend 中
      const locationItem = this.searchFormItem('location')
      if (locationItem?.props?.disabled === true) {
        // 货位不可录入
        _paramsExtend.location = scanData.get('location')
      }

      // 将 _paramsExtend 上面的各属性，赋值给 _params[this.dataGoodsKeepingKey]
      Object.keys(_paramsExtend).forEach((path) => {
        objectUtil.setValueByPath(_params[this.dataGoodsKeepingKey], path, _paramsExtend[path])
      })

      //
      const detailId = objectUtil.getValueByPath(this.scanFormData, `${this.dataGoodsInfoKey}.id`)

      //如果未配置查询接口，说明此处是前端搜索
      if (!scanTableDataInfoUrl) {
        const _data = this.seachScanTableData(
          _params[this.dataGoodsKeepingKey],
          _paramsExtend?.location
        )

        // 扫码后查询到的商品信息集
        this.scanTableData = _data ?? []
        // 判断是否匹配到任务，如果未匹配则给出错误提示
        this.ifEmptyForScanTableData(this.nodataErrorMessage)

        if (lodashUtils.isEmpty(_data) && !detailId) {
          this.jump({ begin: true })
        }

        return
      }

      const goodsId = row?.[this.dataGoodsInfoKey]?.id || detailId
      if (!['CUSTOM_SERIALNUMBER'].includes(this.scanType)) {
        if (!goodsId) {
          this.updateWarnOrErrorMessage(this.nodataErrorMessage, 'error')
          this.jump({ begin: true })
          return
        }
      }

      const goodsKeepingParams = _params[this.dataGoodsKeepingKey]
      const locationId = this.scanFormData.location?.id
      //如果有items，就将上表传给后端
      if (this.scanTableDataInfoParam?.parameters?.items) {
        this.scanTableDataInfoParam.parameters.items = this.tableData
      }
      const parameters = {
        ...this.scanTableDataInfoParam,
        parameters: {
          ...params,
          ...this.scanTableDataInfoParam?.parameters,
          ...goodsKeepingParams,
          locationId,
          goodsId,
        },
      }

      // 状态：编辑时
      const targetId = goodsInfo?.[this.dataGoodsKeepingKey]?.target?.id
      // 修改传递的参数中 targetId 的 keyName，目前改为 targetOrgId。注意：即使配置了 targetOrgId，但依然会以商品的 targetId 值为优先
      if (this.scanStatus === 'update' || !parameters.parameters.targetOrgId) {
        parameters.parameters.targetOrgId = targetId
      }
      // 修复Bug，收货单扫码时点击【编辑】，获取 targetId，如果未获取到值则不传递 targetId
      if (
        Object.prototype.hasOwnProperty.call(parameters.parameters, 'targetId') &&
        !this.passTargetId &&
        (this.scanStatus !== 'update' || !targetId)
      ) {
        delete parameters.parameters.targetId
      }

      // #6553,根据系统策略判断，是否自动设置商品档案的序列号管理
      if (!this.isAutoSerial) {
        if ('serialNumber' in parameters.parameters) {
          delete parameters.parameters.serialNumber
        }
        // 删除值为 undefined 或 null 的参数
        for (const key in parameters.parameters) {
          if (Object.prototype.hasOwnProperty.call(parameters.parameters, key)) {
            if (parameters.parameters[key] == null) delete parameters.parameters[key]
          }
        }
      }

      if (scanTableDataInfoUrl) {
        const res = await this.$axios.post(scanTableDataInfoUrl, parameters).catch((error) => {
          console.error(error?.message)
        })
        if (res.data?.code !== 200) {
          this.updateWarnOrErrorMessage(res.data?.msg || this.nodataErrorMessage, 'error')
          if (!detailId) this.jump({ begin: true })
        }

        // 扫码后查询到的商品信息集
        this.scanTableData = res.data.data ?? []
        // 判断是否匹配到任务，如果未匹配则给出错误提示
        this.ifEmptyForScanTableData(this.nodataErrorMessage)
      }
    },
    seachScanTableData(goodsKeeping, location) {
      console.log('search scan table data params: ', goodsKeeping)
      let paramMap = new Map()
      if (location) {
        paramMap.set('location.id', location?.id)
      }
      if (this.scanFormData[this.dataGoodsInfoKey].id)
        paramMap.set(`${this.dataGoodsInfoKey}.id`, this.scanFormData[this.dataGoodsInfoKey].id)
      for (let key in goodsKeeping) {
        if (
          key !== 'periodEnd' &&
          key !== 'periodExpire' &&
          key !== 'location' &&
          (goodsKeeping[key] || goodsKeeping[key] === 0)
        )
          paramMap.set(`${this.dataGoodsKeepingKey}.${key}`, goodsKeeping[key])
      }
      //开始搜索
      const tempArr = this.dataSource.filter((item) => {
        let temp = true
        for (let [key, val] of paramMap) {
          if (objectUtil.getValueByPath(item, key) !== val) {
            temp = false
            break
          }
        }
        return temp
      })
      //只过滤主行和待处理数量大于已扫数量的行
      if (this.treeRes && tempArr?.length) {
        let dataMap = new Map()
        this.tableData.map((item) => {
          let temp = dataMap.get(item.parent)
          if (temp) {
            temp.push(item)
          } else {
            dataMap.set(item.parent, [item])
          }
        })
        return tempArr.filter((item) => {
          let tempData = dataMap.get(item.parent)
          if (
            tempData &&
            item.master &&
            item.plan >
              tempData.reduce(
                (acc, cur) => calculateUtil.numberAdd(acc, cur[this.dataAmountKey]),
                0
              )
          ) {
            return true
          } else {
            return false
          }
        })
      } else {
        return tempArr
      }
    },
    //获取货位信息
    getLocationInfo(code, parameters = {}) {
      return new Promise((resolve, reject) => {
        const params = { ...parameters, ...this.locationScanInfoParams }
        params.code = code

        this.$axios
          .post(this.locationScanInfoUrl, params)
          .then((res) => {
            if (res.data.code !== 200) {
              this.$Message.error({
                content: res.data?.msg,
                duration: 5,
              })
              reject({ success: false, message: res.data?.msg })
              return
            }
            resolve(res.data?.data)
          })
          .catch((error) => {
            console.error(error?.message)
            reject(null)
          })
      })
    },
    // 等待选择规格/型号
    waitSelectModel() {
      return new Promise((resolve, reject) => {
        try {
          this.resolveSelectModel = resolve
        } catch (error) {
          console.error(error?.message)
          reject()
        }
      })
    },
    // 根据优联或灵科系统，确定是否显示表单项
    visibleSerialArea() {
      const serialItem = this.searchFormItem(`${this.dataGoodsKeepingKey}.serialNumber`, [
        this.serialAreaColumns,
      ])
      const serialCustomItem = this.searchFormItem(`${this.dataGoodsKeepingKey}.epc`, [
        this.serialAreaColumns,
      ])

      return (serialItem && this.keepingSerial) || (serialCustomItem && this.keepingCustomSerial)
    },
    // 根据 serialAreaColumns 元素确定是否显示表单项
    visibleSerialAreaItem(data) {
      if (/\.serialNumber$/.test(data.code)) {
        return this.keepingSerial
      }
      if (/\.epc$/.test(data.code)) {
        return this.keepingCustomSerial
      }
      return false
    },
    // 行编辑
    async editRow(row) {
      console.log('行编辑', row)
      this.scanStatus = 'update'
      this.$set(this, 'scanFormData', objectUtil.clone(row))
      this.scanFormData[this.dataAmountKey] =
        row[this.dataAmountKey] || row[this.dataGoodsInfoKey]?.barcodeAmount || 1
      this.code = ''
      this.$refs.areaScanInput.focus()
      this.skip(row)

      await this.queryTableDataList(null, row)
    },
    // 行删除
    deleteRow(row) {
      console.log('行删除', row)
      this.selectionIds = { [row._ID]: row }
      this.deleteBatch('tableData')
      this.deleteBatch('taskData')
    },
    // 批量删除
    deleteBatch(_dataKey = 'tableData') {
      console.log('开始批量删除', this.selectionIds)
      const dataKey = typeof _dataKey === 'string' ? _dataKey : 'tableData'
      if (!lodashUtils.isEmpty(this.selectionIds)) {
        this[dataKey] = this[dataKey].filter((row) => {
          // 待删除项
          const delItem = this.selectionIds[row._ID]
          if (delItem) {
            if (!delItem.children) {
              // 删除后需清除
              if (dataKey === 'taskData') delete this.selectionIds[row._ID]
              // 有待删除项
              return false
            } else {
              this.selectionChange(delItem.children)
              if (dataKey === 'tableData') this.deleteBatch('tableData')
              if (dataKey === 'taskData') this.deleteBatch('taskData')
            }
          } else {
            // 没有待删除项则忽略删除
            return true
          }
        })
      }
      console.log('完成批量删除: ', this.selectionIds)
    },
    // 表格选中数据变化
    selectionChange(selection) {
      console.log('selection: ', selection)
      this.selectionIds = selection?.reduce(
        (prev, row) => {
          return { ...prev, [row._ID]: row }
        },
        { ...this.selectionIds }
      )
      console.log('选中数据 selectionIds: ', this.selectionIds)
    },
    // 重置表单项（只处理配置了货位的情况）
    resetFormItem() {
      const locationItem = this.searchFormItem('location')
      if (locationItem && locationItem.tip) {
        this.$set(locationItem, 'tip', null)
      }
    },
    // 搜索框输入改变后
    onSearchChange: lodashUtils.debounce(function () {
      const elSearch = this.$refs.searchInput
      this.keyword = elSearch.$data.currentValue
    }, 100),
    /**
     * 选中规格/型号
     *
     * @param {*} item 选中的商品
     * @param {number} item.barcodeAmount 包装/规格 即用此值更新数量
     */
    onSelectModel(item) {
      console.log('选中的规格/型号: ', item)
      // 已选中规格/型号，执行 this.resolveSelectModel
      if (this.resolveSelectModel) this.resolveSelectModel(item)
      // 关闭 Modal
      this.isSelectModel = false
      // 焦点自动移入扫码输入框
      this.$refs.areaScanInput.focus()
      this.$emit('on-select-model', item.model, item)
    },
    // 关闭选规格/型号
    onCancelSelectModel() {
      // 焦点自动移入扫码输入框
      this.$refs.areaScanInput.focus()
    },
    onClose() {
      return new Promise(() => {
        if (this.isPureSaving) {
          // 正在保存时不可关闭，修复Bug#32319
          this.$pgMessage.confirm({
            title: '确认要退出扫码吗？',
            content: '正在保存数据，不可关闭！',
            sureBtnText: '确定',
            showCancelBtn: false,
            showSureBtnRight: false,
            onOk: function onOk() {
              this.$emit('on-cancel')
            },
          })
        } else {
          if (this.isSave) {
            this.$pgMessage.confirm({
              title: '确认要退出扫码吗？',
              content: '还有数据未保存，确认关闭？',
              sureBtnText: '放弃保存',
              sureBtnTextRight: '保存并关闭',
              showSureBtnRight: true,
              onOk: () => {
                console.log('放弃保存')
                this.$emit('on-cancel')
                this.onDrawerClose()
              },
              onOkRight: async () => {
                console.log('保存并关闭')
                await this.startSave('on-ok')
                this.onDrawerClose()
              },
            })
          } else {
            this.$emit('on-cancel')
            this.onDrawerClose()
          }
        }
      })
    },
    // 清空扫码输入框
    clearInput() {
      this.code = ''
      this.inputValue = ''
      if (this.$refs?.areaScanInput) this.$refs.areaScanInput.currentValue = ''
    },
    // 清空
    onClear() {
      console.log('清空')
      this.scanTableData = []
      this.analysisMessages = []
      this.goodsInfo = {}
      this.clearInput()
      this.resetWarnOrErrorMessage()
      this.resetScanFormData()
      this.resetScanResult() // 修复 Bugfix #31061

      this.resetFormItem()

      this.$refs.areaScanInput.focus()
      console.log('当前步骤: ', this.scanCurrentStep)
    },
    // 关闭 Drawer
    onDrawerClose() {
      const id = this.formDataAfterScan?.order?.id
      if (id) {
        // 如果扫码后 formData.order.id 有值，说明是暂存后，则需要调整页面至编辑页
        window.$vueApp.$router.replace({ query: { id } })
      }

      this.$emit('input', false)
    },
    // 扫码模式变化后，重置扫码信息
    onChangeScanType() {
      console.log('扫码模式变化后，重置扫码信息')
      // Bug#31302，切换扫码类别时，如果匹配到任务则不清空表单项
      if (this.scanTableData?.length > 0) return
      this.resetScanFormData()
    },
    // 连续扫码模式下：非序列号管理商品，清空扫码区/禁用锁定/给出提示 等处理
    noSerialManage() {
      console.log(this.mode, this.keepingSerial, this.keepingCustomSerial)
      const detailId = this.scanFormData[this.dataGoodsInfoKey]?.id
      // 序列号连续扫模式
      if (this.mode === 'series') {
        // 非序列号管理
        if (detailId && !this.keepingSerial && !this.keepingCustomSerial) {
          this.updateWarnOrErrorMessage(this.seriesErrorMessage, 'error')
          // 非序列号商品，则清空扫码区
          // this.resetScanFormData()
          // 禁用锁定
          this.disabledLock = true
        } else {
          this.disabledLock = false
        }
      }
      // 标准模式
      else {
        this.isLock = false
        this.disabledLock = false
        // this.lockAreaColumns(this.isLock)
      }
    },
    // 自动确认提交
    onAutoConfirm() {
      if (!this.isLock) return
      // 判断是否自动提交，disabledAutoSubmit 为 true 则禁用自动确认提交
      console.log('是否配置了禁用自动提交: ', this.disabledAutoSubmit)
      if (!this.disabledAutoSubmit) {
        const { data: scanData } = this.scanResult
        const serialNumber = scanData.get('serialNumber')
        const epc = scanData.get('epc')

        // 锁定时，scanFormData 上的 serialNumber 和 epc 都被清空，需要重新赋值
        if (serialNumber)
          objectUtil.setValueByPath(
            this.scanFormData,
            `${this.dataGoodsKeepingKey}.serialNumber`,
            serialNumber
          )
        if (epc)
          objectUtil.setValueByPath(this.scanFormData, `${this.dataGoodsKeepingKey}.epc`, epc)
        // 是否配置了序列号的表单项
        const epcItem = this.searchFormItem(`${this.dataGoodsKeepingKey}.epc`, [
          this.serialAreaColumns,
        ])
        const serialItem = this.searchFormItem(`${this.dataGoodsKeepingKey}.serialNumber`, [
          this.serialAreaColumns,
        ])

        const onlySerial = serialItem && !epcItem && this.keepingSerial && serialNumber
        const onlyEpc = epcItem && !serialItem && this.keepingCustomSerial && epc
        const isDouble =
          epcItem &&
          serialItem &&
          this.keepingSerial &&
          this.keepingCustomSerial &&
          serialNumber &&
          epc

        if (onlySerial || onlyEpc || isDouble) {
          console.log('开始自动确认提交')
          this.onScanConfirm()
        }
      }
    },
    // 请求后台 获取保质期等其他计算数据
    getLife() {
      const goodsId = this.goodsInfo?.id
      if (this.validDateUrl && goodsId) {
        this.$axios
          .get(this.validDateUrl, {
            params: {
              orderId: this.orderId,
              goodsId: goodsId,
              // item:this.index
            },
          })
          .then((res) => {
            if (res.data.code === 200) {
              if (!this.$cfn.ajax1.isOK(res, this)) return
              const item = res.data.data
              if (item) {
                this.unit = objectUtil.getValueByPath(item, 'goods.period.unit.name')
                this.calc = objectUtil.getValueByPath(item, 'goods.period.calc.name')
                this.life = objectUtil.getValueByPath(item, 'goods.period.life')
              }
            }
          })
      }
    },
    // 获取策略
    getPolicySetting() {
      if (!this.policy) {
        this.policy = objectUtil.getValueByPath(
          this.$store,
          'state.strategy.strategy.ISCC_TWO_WAY_PERIOD',
          null
        )
      }
    },
    /** @name 根据props.checkArr和扫码的各后置逻辑，生成最新的checkArr */
    setCheckArr() {
      const ifArr = Object.prototype.toString.call(this.checkArr) === '[object Array]'
      const checkArr = ifArr
        ? objectUtil.clone(this.checkArr.map((key) => `${this.dataGoodsKeepingKey}.${key}`))
        : []

      if (checkArr.length === 0) {
        checkArr.push(
          ...[
            `${this.dataGoodsInfoKey}.id`,
            `${this.dataGoodsKeepingKey}.periodBegin`,
            `${this.dataGoodsKeepingKey}.periodEnd`,
            `${this.dataGoodsKeepingKey}.batchNumber`,
          ]
        )
      } else {
        checkArr.push(`${this.dataGoodsInfoKey}.id`)
      }

      return checkArr
    },
    //----------------------------扫码确认及之后的逻辑----------------------------------------------
    /**
     * pureSave 保存前处理 res.data 的数据，保持数据顺序和原 formData.items 顺序一致
     *
     * @param {Array} items 传递给 pureSaveOfUrl 接口的商品明细数据
     * @returns {*} formData
     */
    handlePureSaveOfData(items = []) {
      // 原表单，轻易不修改原表单的结构和数据，保持其原样性
      const formData = objectUtil.clone(this.formDataAfterScan ?? this.formData)

      if (!formData.items || formData.items?.length === 0) {
        // 原表单的商品明细 items 无数据，将 items 赋值给 formData.items
        formData.items = items
        return formData
      } else if (!items?.length) {
        // 原表单的商品明细 items 有数据但 items 无数据时，则直接返回 formData
        return formData
      }

      /********** 下面执行主从行或非主从行的重新排序，保持与原表单商品明细的顺序一致 **********/
      // 修复#36113
      if (['importInventory'].includes(this.model)) {
        formData.items = items
      }

      const idKey = this.treeRes ? 'parent' : 'id' // true: 主从行，false: 非主从行
      const itemsMap = objectUtil.arrToMapByKey(items, idKey)
      const formItemsMap = objectUtil.arrToMapByKey(formData.items, idKey)

      for (let [key, val] of formItemsMap) {
        let temVal = objectUtil.arrMergeByKey(val, itemsMap.get(key), '_ID')
        formItemsMap.set(key, temVal)
      }

      let tempArr = [...formItemsMap.values()]
      formData.items = tempArr.reduce((acc, cur) => [...acc, ...cur], [])

      return formData
    },
    /**
     * 执行保存动作
     * @param {String} eventName 提交的事件名 可选值 on-ok、on-ok-and-continue
     * @param {Function} fnCallback 回调方法，用于执行后续动作
     *
     */
    startSave(eventName) {
      return new Promise(async (resolve, reject) => {
        if (!eventName) reject('eventName 不可为空！')
        this.topRemindErrors = null
        // 保存前执行
        const res = await this.saveBefore()
        if (res.code === 200) {
          const eventData = {
            data: {
              code: res.code,
              data: res.data,
            },
          }

          // 优联，需求#5559【优联-web-云南骨科】扫码验收支持服务端暂存扫码结果
          if (!this.isLinkOfSystem && this.pureSaveOfUrl && !this.disabledPureSave) {
            let formData = this.handlePureSaveOfData(res.data)

            this.$Loading.start()
            this.isPureSaving = true
            this.$axios
              .post(this.pureSaveOfUrl, formData)
              .then((response) => {
                this.$Loading.finish()
                if (!this.$cfn.ajax1.isOK(response, this)) {
                  this.isPureSaving = false
                  return reject()
                }

                formData = response.data.data // 用接口返回的表单数据，重新赋值了该变量
                // 函数 handlePureSaveOfData 中，会优先使用 formDataAfterScan 的值生成传递给暂存接口的 formData
                this.formDataAfterScan = formData

                eventData.isUpdateFormDataAll = true
                eventData.formData = formData

                this.$emit(eventName, eventData)
                // 保存成功后
                this.isSave = false

                resolve()
              })
              .catch((error) => {
                this.$Loading.error()
                this.$cfn.ajax1.catch1(error, this)
                reject(error.message)
              })
              .finally(() => {
                this.isPureSaving = false
              })
          } else {
            this.$emit(eventName, eventData)
            // 保存成功后
            this.isSave = false

            resolve()
          }
        } else {
          this.topRemindErrors = res
          reject(res.msg)
        }
      })
    },
    // 提交保存
    async onSave() {
      await this.startSave('on-ok-and-continue')
      this.$Message.success('成功')
      this.initComponent(0, true)
    },
    /**
     * @name  根据扫的条码生成厂家原始条码
     * @description 需要在调用 onClear 之前执行
     */
    createOriginBarCode() {
      // #6553,根据系统策略判断是否写入厂家原始条码
      if (!this.isAutoSerial) return
      const scanData = this.scanCurrentResult
      const scanPrint = this.scanResult.print
      const scanOrigin = this.scanResult.origin
      const gtin = scanData.get('gtin')
      const originBarCodeValue = objectUtil.getValueByPath(
        this.scanFormData,
        `${this.dataGoodsKeepingKey}.originBarCode`
      )
      const originBarCodeDisplayValue = objectUtil.getValueByPath(
        this.scanFormData,
        `${this.dataGoodsKeepingKey}.originBarCodeDisplay`
      )
      // #33576，扫69码，没有拼出原厂条码字段
      const codeType = this.scanResult.codeType
      const scanType = this.getScanType()
      let { isMa, isHibc } = scanType

      const haveBracket = codeType && !isMa && !isHibc && this.isBracket === 'YES'
      const printBracketValue = haveBracket ? scanPrint?.bracket : scanPrint?.ordinary

      // 扫到 DI
      if (gtin) {
        if (scanOrigin) {
          objectUtil.setValueByPath(
            this.scanFormData,
            `${this.dataGoodsKeepingKey}.originBarCode`,
            scanOrigin
          )
        }
        if (printBracketValue) {
          objectUtil.setValueByPathForVue(
            this.scanFormData,
            `${this.dataGoodsKeepingKey}.originBarCodeDisplay`,
            printBracketValue,
            this
          )
        }
      }
      // 分段扫
      else if (`${originBarCodeValue || ''}`.indexOf(scanOrigin) < 0) {
        let separator = 'ñ'
        if (isMa || isHibc) separator = ''
        if (scanOrigin) {
          objectUtil.setValueByPath(
            this.scanFormData,
            `${this.dataGoodsKeepingKey}.originBarCode`,
            originBarCodeValue ? originBarCodeValue + separator + scanOrigin : scanOrigin
          )
        }
        if (printBracketValue) {
          objectUtil.setValueByPathForVue(
            this.scanFormData,
            `${this.dataGoodsKeepingKey}.originBarCodeDisplay`,
            originBarCodeDisplayValue
              ? originBarCodeDisplayValue + printBracketValue
              : printBracketValue,
            this
          )
        }
      }
    },
  },
}
